var items = {
  "block.minecraft.acacia_button": "Acaciahoutere knupke",
  "block.minecraft.acacia_door": "Acaciahoutere deur",
  "block.minecraft.acacia_fence": "Acaciahoutere hekke",
  "block.minecraft.acacia_fence_gate": "Acaciahoutere poewert",
  "block.minecraft.acacia_hanging_sign": "Acaciahouten hangbord",
  "block.minecraft.acacia_leaves": "Acaciablaojer",
  "block.minecraft.acacia_log": "Acaciastam",
  "block.minecraft.acacia_planks": "Acaciahoutere plaank",
  "block.minecraft.acacia_pressure_plate": "Acaciahoutere drôkplôat",
  "block.minecraft.acacia_sapling": "Acaciakiemplent",
  "block.minecraft.acacia_shelf": "Acaciahouten schap",
  "block.minecraft.acacia_sign": "Acaciahoutere burd",
  "block.minecraft.acacia_slab": "Acaciahoutere plôat",
  "block.minecraft.acacia_stairs": "Acaciahoutere trep",
  "block.minecraft.acacia_trapdoor": "Acaciahoutere vaalluuk",
  "block.minecraft.acacia_wall_hanging_sign": "Acaciahouten uithangbord",
  "block.minecraft.acacia_wall_sign": "Acaciahoutere burd an waand",
  "block.minecraft.acacia_wood": "Acaciahout",
  "block.minecraft.activator_rail": "Activaosierels",
  "block.minecraft.air": "Lucht",
  "block.minecraft.allium": "Look",
  "block.minecraft.amethyst_block": "Amethistblok",
  "block.minecraft.amethyst_cluster": "Amethistcluster",
  "block.minecraft.ancient_debris": "Aaw puun",
  "block.minecraft.andesite": "Andesiet",
  "block.minecraft.andesite_slab": "Andesietplôat",
  "block.minecraft.andesite_stairs": "Andesiettrep",
  "block.minecraft.andesite_wall": "Andesietwaand",
  "block.minecraft.anvil": "Ònbild",
  "block.minecraft.attached_melon_stem": "Vaste meloenstam",
  "block.minecraft.attached_pumpkin_stem": "Vaste pompoenstam",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Azaleabloajer",
  "block.minecraft.azure_bluet": "Porseleinsterretje",
  "block.minecraft.bamboo": "Bamboe",
  "block.minecraft.bamboo_block": "Bamboeblok",
  "block.minecraft.bamboo_button": "Bamboeknop",
  "block.minecraft.bamboo_door": "Bamboedeur",
  "block.minecraft.bamboo_fence": "Bamboehek",
  "block.minecraft.bamboo_fence_gate": "Bamboepoort",
  "block.minecraft.bamboo_hanging_sign": "Bamboehangbord",
  "block.minecraft.bamboo_mosaic": "Bamboemozaïek",
  "block.minecraft.bamboo_mosaic_slab": "Bamboemozaïekplaat",
  "block.minecraft.bamboo_mosaic_stairs": "Bamboemozaïektrap",
  "block.minecraft.bamboo_planks": "Bamboeplanken",
  "block.minecraft.bamboo_pressure_plate": "Bamboedrukplaat",
  "block.minecraft.bamboo_sapling": "Bamboesjeut",
  "block.minecraft.bamboo_shelf": "Bamboeschap",
  "block.minecraft.bamboo_sign": "Bamboebord",
  "block.minecraft.bamboo_slab": "Bamboeplaat",
  "block.minecraft.bamboo_stairs": "Bamboetrap",
  "block.minecraft.bamboo_trapdoor": "Bamboevalluik",
  "block.minecraft.bamboo_wall_hanging_sign": "Bamboe-uithangbord",
  "block.minecraft.bamboo_wall_sign": "Bamboebord aan muur",
  "block.minecraft.banner.base.black": "Zwert veld",
  "block.minecraft.banner.base.blue": "Blaaw veld",
  "block.minecraft.banner.base.brown": "Brèùn veld",
  "block.minecraft.banner.base.cyan": "Turquoise veld",
  "block.minecraft.banner.base.gray": "Grèès veld",
  "block.minecraft.banner.base.green": "Grún veld",
  "block.minecraft.banner.base.light_blue": "Liechtblaaw veld",
  "block.minecraft.banner.base.light_gray": "Liechtgrèès veld",
  "block.minecraft.banner.base.lime": "Liechtgrún",
  "block.minecraft.banner.base.magenta": "Magenta veld",
  "block.minecraft.banner.base.orange": "Oranje veld",
  "block.minecraft.banner.base.pink": "Raaze veld",
  "block.minecraft.banner.base.purple": "Péérs veld",
  "block.minecraft.banner.base.red": "Rooi veld",
  "block.minecraft.banner.base.white": "Wiet veld",
  "block.minecraft.banner.base.yellow": "Gèèl veld",
  "block.minecraft.banner.border.black": "Zwart borduursel",
  "block.minecraft.banner.border.blue": "Blauw borduursel",
  "block.minecraft.banner.border.brown": "Bruin borduursel",
  "block.minecraft.banner.border.cyan": "Cyaan borduursel",
  "block.minecraft.banner.border.gray": "Grijs borduursel",
  "block.minecraft.banner.border.green": "Gruune zoom",
  "block.minecraft.banner.border.light_blue": "Lichtblauw borduursel",
  "block.minecraft.banner.border.light_gray": "Lichtgrijs borduursel",
  "block.minecraft.banner.border.lime": "Lichtgroen borduursel",
  "block.minecraft.banner.border.magenta": "Magenta borduursel",
  "block.minecraft.banner.border.orange": "Oranje borduursel",
  "block.minecraft.banner.border.pink": "Roze borduursel",
  "block.minecraft.banner.border.purple": "Péérse zoom",
  "block.minecraft.banner.border.red": "Rood borduursel",
  "block.minecraft.banner.border.white": "Wit borduursel",
  "block.minecraft.banner.border.yellow": "Geel borduursel",
  "block.minecraft.banner.bricks.black": "Zwart metselwerk",
  "block.minecraft.banner.bricks.blue": "Blauw metselwerk",
  "block.minecraft.banner.bricks.brown": "Bruin metselwerk",
  "block.minecraft.banner.bricks.cyan": "Cyaan metselwerk",
  "block.minecraft.banner.bricks.gray": "Grijs metselwerk",
  "block.minecraft.banner.bricks.green": "Gruun veld gemetseld",
  "block.minecraft.banner.bricks.light_blue": "Lichtblauw metselwerk",
  "block.minecraft.banner.bricks.light_gray": "Lichtgrijs metselwerk",
  "block.minecraft.banner.bricks.lime": "Lichtgroen metselwerk",
  "block.minecraft.banner.bricks.magenta": "Magenta metselwerk",
  "block.minecraft.banner.bricks.orange": "Oranje metselwerk",
  "block.minecraft.banner.bricks.pink": "Roze metselwerk",
  "block.minecraft.banner.bricks.purple": "Péérs veld gemetseld",
  "block.minecraft.banner.bricks.red": "Rood metselwerk",
  "block.minecraft.banner.bricks.white": "Wit metselwerk",
  "block.minecraft.banner.bricks.yellow": "Geel metselwerk",
  "block.minecraft.banner.circle.black": "Zwarte roundel",
  "block.minecraft.banner.circle.blue": "Blauwe roundel",
  "block.minecraft.banner.circle.brown": "Bruine roundel",
  "block.minecraft.banner.circle.cyan": "Cyaan roundel",
  "block.minecraft.banner.circle.gray": "Grijze roundel",
  "block.minecraft.banner.circle.green": "Gruun rozet",
  "block.minecraft.banner.circle.light_blue": "Lichtblauwe roundel",
  "block.minecraft.banner.circle.light_gray": "Lichtgrijze roundel",
  "block.minecraft.banner.circle.lime": "Lichtgroene roundel",
  "block.minecraft.banner.circle.magenta": "Magenta Roundel",
  "block.minecraft.banner.circle.orange": "Oranje Roundel",
  "block.minecraft.banner.circle.pink": "Roze roundel",
  "block.minecraft.banner.circle.purple": "Péérs rozet",
  "block.minecraft.banner.circle.red": "Rode roundel",
  "block.minecraft.banner.circle.white": "Witte Roundel",
  "block.minecraft.banner.circle.yellow": "Gele roundel",
  "block.minecraft.banner.creeper.black": "Zwart Creeper symbool",
  "block.minecraft.banner.creeper.blue": "Blauw Creeper symbool",
  "block.minecraft.banner.creeper.brown": "Bruin Creeper symbool",
  "block.minecraft.banner.creeper.cyan": "Cyaan Creeper symbool",
  "block.minecraft.banner.creeper.gray": "Grijs Creeper symbool",
  "block.minecraft.banner.creeper.green": "Gruun Creeperwapen",
  "block.minecraft.banner.creeper.light_blue": "Lichtblauw Creeper symbool",
  "block.minecraft.banner.creeper.light_gray": "Lichtgrijs Creeper symbool",
  "block.minecraft.banner.creeper.lime": "Lichtgroen Creeper symbool",
  "block.minecraft.banner.creeper.magenta": "Magenta Creeper symbool",
  "block.minecraft.banner.creeper.orange": "Oranje Creeper symbool",
  "block.minecraft.banner.creeper.pink": "Roze Creeper symbool",
  "block.minecraft.banner.creeper.purple": "Péérs Creeperwapen",
  "block.minecraft.banner.creeper.red": "Rood Creeper symbool",
  "block.minecraft.banner.creeper.white": "Wit Creeper symbool",
  "block.minecraft.banner.creeper.yellow": "Geel Creeper symbool",
  "block.minecraft.banner.cross.black": "Zwart andreaskruis",
  "block.minecraft.banner.cross.blue": "Blauw andreaskruis",
  "block.minecraft.banner.cross.brown": "Bruin andreaskruis",
  "block.minecraft.banner.cross.cyan": "Cyaan andreaskruis",
  "block.minecraft.banner.cross.gray": "Grijs andreaskruis",
  "block.minecraft.banner.cross.green": "Gruun andreaskruis",
  "block.minecraft.banner.cross.light_blue": "Lichtblauw andreaskruis",
  "block.minecraft.banner.cross.light_gray": "Lichtgrijs andreaskruis",
  "block.minecraft.banner.cross.lime": "Lichtgroen andreaskruis",
  "block.minecraft.banner.cross.magenta": "Magenta andreaskruis",
  "block.minecraft.banner.cross.orange": "Oranje andreaskruis",
  "block.minecraft.banner.cross.pink": "Roze andreaskruis",
  "block.minecraft.banner.cross.purple": "Péérs andreaskruis",
  "block.minecraft.banner.cross.red": "Rood andreaskruis",
  "block.minecraft.banner.cross.white": "Wit andreaskruis",
  "block.minecraft.banner.cross.yellow": "Geel andreaskruis",
  "block.minecraft.banner.curly_border.black": "Zwart ingesprongen borduursel",
  "block.minecraft.banner.curly_border.blue": "Blauw ingesprongen borduursel",
  "block.minecraft.banner.curly_border.brown": "Bruin ingesprongen borduursel",
  "block.minecraft.banner.curly_border.cyan": "Cyaan ingesprongen borduursel",
  "block.minecraft.banner.curly_border.gray": "Grijs ingesprongen borduursel",
  "block.minecraft.banner.curly_border.green": "Gruune ingesprongen zoom",
  "block.minecraft.banner.curly_border.light_blue": "Lichtblauw ingesprongen borduursel",
  "block.minecraft.banner.curly_border.light_gray": "Lichtgrijs ingesprongen borduursel",
  "block.minecraft.banner.curly_border.lime": "Lichtgroen ingesprongen borduursel",
  "block.minecraft.banner.curly_border.magenta": "Magenta ingesprongen borduursel",
  "block.minecraft.banner.curly_border.orange": "Oranje ingesprongen borduursel",
  "block.minecraft.banner.curly_border.pink": "Roze ingesprongen borduursel",
  "block.minecraft.banner.curly_border.purple": "Péérse ingesprongen zoom",
  "block.minecraft.banner.curly_border.red": "Rood ingesprongen borduursel",
  "block.minecraft.banner.curly_border.white": "Wit ingesprongen borduursel",
  "block.minecraft.banner.curly_border.yellow": "Geel ingesprongen borduursel",
  "block.minecraft.banner.diagonal_left.black": "Zwart schuin-links verdeeld",
  "block.minecraft.banner.diagonal_left.blue": "Blauw schuin-links verdeeld",
  "block.minecraft.banner.diagonal_left.brown": "Bruin schuin-links verdeeld",
  "block.minecraft.banner.diagonal_left.cyan": "Cyaan schuin-links verdeeld",
  "block.minecraft.banner.diagonal_left.gray": "Grijs schuin-links verdeeld",
  "block.minecraft.banner.diagonal_left.green": "Gruune per band sinister",
  "block.minecraft.banner.diagonal_left.light_blue": "Lichtblauw schuin-links verdeeld",
  "block.minecraft.banner.diagonal_left.light_gray": "Lichtgrijs schuin-links verdeeld",
  "block.minecraft.banner.diagonal_left.lime": "Lichtgroen schuin-links verdeeld",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta schuin-links verdeeld",
  "block.minecraft.banner.diagonal_left.orange": "Oranje schuin-links verdeeld",
  "block.minecraft.banner.diagonal_left.pink": "Roze schuin-links verdeeld",
  "block.minecraft.banner.diagonal_left.purple": "Péérse per band sinister",
  "block.minecraft.banner.diagonal_left.red": "Rood schuin-links verdeeld",
  "block.minecraft.banner.diagonal_left.white": "Wit schuin-links verdeeld",
  "block.minecraft.banner.diagonal_left.yellow": "Geel schuin-links verdeeld",
  "block.minecraft.banner.diagonal_right.black": "Zwart schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_right.blue": "Blauw schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_right.brown": "Bruin schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_right.cyan": "Cyaan schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_right.gray": "Grijs schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_right.green": "Gruune per band",
  "block.minecraft.banner.diagonal_right.light_blue": "Lichtblauw schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_right.light_gray": "Lichtgrijs schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_right.lime": "Lichtgroen schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_right.orange": "Oranje schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_right.pink": "Roze schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_right.purple": "Péérse per band",
  "block.minecraft.banner.diagonal_right.red": "Rood schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_right.white": "Wit schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_right.yellow": "Geel schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.black": "Zwart omgekeerd schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.blue": "Blauw omgekeerd schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.brown": "Bruin omgekeerd schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.cyan": "Cyaan omgekeerd schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.gray": "Grijs omgekeerd schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.green": "Gruune per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Lichtblauw omgekeerd schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Lichtgrijs omgekeerd schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.lime": "Lichtgroen omgekeerd schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta omgekeerd schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.orange": "Oranje omgekeerd schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.pink": "Roze omgekeerd schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.purple": "Péérse per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.red": "Rood omgekeerd schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.white": "Wit omgekeerd schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.yellow": "Geel omgekeerd schuin-rechts verdeeld",
  "block.minecraft.banner.diagonal_up_right.black": "Zwart omgekeerd schuin-links verdeeld",
  "block.minecraft.banner.diagonal_up_right.blue": "Blauw omgekeerd schuin-links verdeeld",
  "block.minecraft.banner.diagonal_up_right.brown": "Bruin omgekeerd schuin-links verdeeld",
  "block.minecraft.banner.diagonal_up_right.cyan": "Cyaan omgekeerd schuin-links verdeeld",
  "block.minecraft.banner.diagonal_up_right.gray": "Grijs omgekeerd schuin-links verdeeld",
  "block.minecraft.banner.diagonal_up_right.green": "Gruune per band sinister omgekeerd",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Lichtblauw omgekeerd schuin-links verdeeld",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Lichtgrijs omgekeerd schuin-links verdeeld",
  "block.minecraft.banner.diagonal_up_right.lime": "Lichtgroen omgekeerd schuin-links verdeeld",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta omgekeerd schuin-links verdeeld",
  "block.minecraft.banner.diagonal_up_right.orange": "Oranje omgekeerd schuin-links verdeeld",
  "block.minecraft.banner.diagonal_up_right.pink": "Roze omgekeerd schuin-links verdeeld",
  "block.minecraft.banner.diagonal_up_right.purple": "Péérse per band sinister omgekeerd",
  "block.minecraft.banner.diagonal_up_right.red": "Rood omgekeerd schuin-links verdeeld",
  "block.minecraft.banner.diagonal_up_right.white": "Wit omgekeerd schuin-links verdeeld",
  "block.minecraft.banner.diagonal_up_right.yellow": "Geel omgekeerd schuin-links verdeeld",
  "block.minecraft.banner.flow.black": "Zwarte windstroming",
  "block.minecraft.banner.flow.blue": "Blauwe windstroming",
  "block.minecraft.banner.flow.brown": "Bruine windstroming",
  "block.minecraft.banner.flow.cyan": "Turquoise windstroming",
  "block.minecraft.banner.flow.gray": "Grijze windstroming",
  "block.minecraft.banner.flow.green": "Groene windstroming",
  "block.minecraft.banner.flow.light_blue": "Lichtblauwe windstroming",
  "block.minecraft.banner.flow.light_gray": "Lichtgrijze windstroming",
  "block.minecraft.banner.flow.lime": "Lichtgroene windstroming",
  "block.minecraft.banner.flow.magenta": "Magenta windstroming",
  "block.minecraft.banner.flow.orange": "Oranje windstroming",
  "block.minecraft.banner.flow.pink": "Roze windstroming",
  "block.minecraft.banner.flow.purple": "Paarse windstroming",
  "block.minecraft.banner.flow.red": "Rode windstroming",
  "block.minecraft.banner.flow.white": "Witte windstroming",
  "block.minecraft.banner.flow.yellow": "Gele windstroming",
  "block.minecraft.banner.flower.black": "Zwart bloemsymbool",
  "block.minecraft.banner.flower.blue": "Blauw bloemsymbool",
  "block.minecraft.banner.flower.brown": "Bruin bloemsymbool",
  "block.minecraft.banner.flower.cyan": "Cyaan bloemsymbool",
  "block.minecraft.banner.flower.gray": "Grijs bloemsymbool",
  "block.minecraft.banner.flower.green": "Gruun bloemwapen",
  "block.minecraft.banner.flower.light_blue": "Lichtblauwe bloem",
  "block.minecraft.banner.flower.light_gray": "Lichtgrijs bloemsymbool",
  "block.minecraft.banner.flower.lime": "Lichtgroene bloem",
  "block.minecraft.banner.flower.magenta": "Magenta bloem",
  "block.minecraft.banner.flower.orange": "Oranje bloem",
  "block.minecraft.banner.flower.pink": "Roze bloem",
  "block.minecraft.banner.flower.purple": "Péérs bloemwapen",
  "block.minecraft.banner.flower.red": "Rood bloemsymbool",
  "block.minecraft.banner.flower.white": "Witte bloem",
  "block.minecraft.banner.flower.yellow": "Gele bloem",
  "block.minecraft.banner.globe.black": "Zwarte globe",
  "block.minecraft.banner.globe.blue": "Blauwe globe",
  "block.minecraft.banner.globe.brown": "Bruine globe",
  "block.minecraft.banner.globe.cyan": "Cyaane globe",
  "block.minecraft.banner.globe.gray": "Grijze globe",
  "block.minecraft.banner.globe.green": "Groene globe",
  "block.minecraft.banner.globe.light_blue": "Lichtblauwe globe",
  "block.minecraft.banner.globe.light_gray": "Lichtgrijze globe",
  "block.minecraft.banner.globe.lime": "Lichtgroene globe",
  "block.minecraft.banner.globe.magenta": "Magenta globe",
  "block.minecraft.banner.globe.orange": "Oranje globe",
  "block.minecraft.banner.globe.pink": "Roze globe",
  "block.minecraft.banner.globe.purple": "Paarse globe",
  "block.minecraft.banner.globe.red": "Rode globe",
  "block.minecraft.banner.globe.white": "Witte globe",
  "block.minecraft.banner.globe.yellow": "Gele globe",
  "block.minecraft.banner.gradient.black": "Zwart gradiënt",
  "block.minecraft.banner.gradient.blue": "Blauw gradiënt",
  "block.minecraft.banner.gradient.brown": "Bruin gradiënt",
  "block.minecraft.banner.gradient.cyan": "Turquoise gradiënt",
  "block.minecraft.banner.gradient.gray": "Grijs gradiënt",
  "block.minecraft.banner.gradient.green": "Gruun gradiënt",
  "block.minecraft.banner.gradient.light_blue": "Lichtblauw gradiënt",
  "block.minecraft.banner.gradient.light_gray": "Lichtgrijs gradiënt",
  "block.minecraft.banner.gradient.lime": "Lichtgroen gradiënt",
  "block.minecraft.banner.gradient.magenta": "Magenta gradiënt",
  "block.minecraft.banner.gradient.orange": "Oranje gradiënt",
  "block.minecraft.banner.gradient.pink": "Roze gradiënt",
  "block.minecraft.banner.gradient.purple": "Péérs gradiënt",
  "block.minecraft.banner.gradient.red": "Rood gradiënt",
  "block.minecraft.banner.gradient.white": "Witte gradiënt",
  "block.minecraft.banner.gradient.yellow": "Geel gradiënt",
  "block.minecraft.banner.gradient_up.black": "Zwarte basis gradiënt",
  "block.minecraft.banner.gradient_up.blue": "Blauwe basis gradiënt",
  "block.minecraft.banner.gradient_up.brown": "Bruine basis gradiënt",
  "block.minecraft.banner.gradient_up.cyan": "Cyaan basis gradiënt",
  "block.minecraft.banner.gradient_up.gray": "Grijze basis gradiënt",
  "block.minecraft.banner.gradient_up.green": "Gruun basis gradiënt",
  "block.minecraft.banner.gradient_up.light_blue": "Lichtblauwe basis gradiënt",
  "block.minecraft.banner.gradient_up.light_gray": "Lichtgrijse basis gradiënt",
  "block.minecraft.banner.gradient_up.lime": "Lichtgroene basis gradiënt",
  "block.minecraft.banner.gradient_up.magenta": "Magenta basis gradiënt",
  "block.minecraft.banner.gradient_up.orange": "Oranje basis gradiënt",
  "block.minecraft.banner.gradient_up.pink": "Roze basis gradiënt",
  "block.minecraft.banner.gradient_up.purple": "Péérs basis gradiënt",
  "block.minecraft.banner.gradient_up.red": "Rode basis gradiënt",
  "block.minecraft.banner.gradient_up.white": "Witte basis gradiënt",
  "block.minecraft.banner.gradient_up.yellow": "Gele basis gradiënt",
  "block.minecraft.banner.guster.black": "Zwarte rukwind",
  "block.minecraft.banner.guster.blue": "Blauwe rukwind",
  "block.minecraft.banner.guster.brown": "Bruine rukwind",
  "block.minecraft.banner.guster.cyan": "Turquoise rukwind",
  "block.minecraft.banner.guster.gray": "Grijze rukwind",
  "block.minecraft.banner.guster.green": "Groene rukwind",
  "block.minecraft.banner.guster.light_blue": "Lichtblauwe rukwind",
  "block.minecraft.banner.guster.light_gray": "Lichtgrijze rukwind",
  "block.minecraft.banner.guster.lime": "Lichtgroene rukwind",
  "block.minecraft.banner.guster.magenta": "Magenta rukwind",
  "block.minecraft.banner.guster.orange": "Oranje rukwind",
  "block.minecraft.banner.guster.pink": "Roze rukwind",
  "block.minecraft.banner.guster.purple": "Paarse rukwind",
  "block.minecraft.banner.guster.red": "Rode rukwind",
  "block.minecraft.banner.guster.white": "Witte rukwind",
  "block.minecraft.banner.guster.yellow": "Gele rukwind",
  "block.minecraft.banner.half_horizontal.black": "Zwartgebalkt",
  "block.minecraft.banner.half_horizontal.blue": "Blauwgebalkt",
  "block.minecraft.banner.half_horizontal.brown": "Bruingebalkt",
  "block.minecraft.banner.half_horizontal.cyan": "Turquoisegebalkt",
  "block.minecraft.banner.half_horizontal.gray": "Grijsgebalkt",
  "block.minecraft.banner.half_horizontal.green": "Gruune per faas",
  "block.minecraft.banner.half_horizontal.light_blue": "Lichtblauwgebalkt",
  "block.minecraft.banner.half_horizontal.light_gray": "Lichtgrijsgebalkt",
  "block.minecraft.banner.half_horizontal.lime": "Lichtgroengebalkt",
  "block.minecraft.banner.half_horizontal.magenta": "Magentagebalkt",
  "block.minecraft.banner.half_horizontal.orange": "Oranjegebalkt",
  "block.minecraft.banner.half_horizontal.pink": "Rozegebalkt",
  "block.minecraft.banner.half_horizontal.purple": "Péérse per faas",
  "block.minecraft.banner.half_horizontal.red": "Roodgebalkt",
  "block.minecraft.banner.half_horizontal.white": "Witgebalkt",
  "block.minecraft.banner.half_horizontal.yellow": "Geelgebalkt",
  "block.minecraft.banner.half_horizontal_bottom.black": "Zwart omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blauw omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Bruin omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cyaan omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grijs omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.green": "Gruune per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Lichtblauw omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Lichtgrijs omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Lichtgroen omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magenta omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oranje omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Roze omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Péérse per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.red": "Rood omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.white": "Wit omgekeerd gebalkt",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Geel omgekeerd gebalkt",
  "block.minecraft.banner.half_vertical.black": "Zwartgepaald",
  "block.minecraft.banner.half_vertical.blue": "Blauwgepaald",
  "block.minecraft.banner.half_vertical.brown": "Bruingepaald",
  "block.minecraft.banner.half_vertical.cyan": "Turquoisegepaald",
  "block.minecraft.banner.half_vertical.gray": "Grijsgepaald",
  "block.minecraft.banner.half_vertical.green": "Gruune per paal",
  "block.minecraft.banner.half_vertical.light_blue": "Lichtblauwgepaald",
  "block.minecraft.banner.half_vertical.light_gray": "Lichtgrijsgepaald",
  "block.minecraft.banner.half_vertical.lime": "Lichtgroengepaald",
  "block.minecraft.banner.half_vertical.magenta": "Magentagepaald",
  "block.minecraft.banner.half_vertical.orange": "Oranjegepaald",
  "block.minecraft.banner.half_vertical.pink": "Rozegepaald",
  "block.minecraft.banner.half_vertical.purple": "Péérse per peel",
  "block.minecraft.banner.half_vertical.red": "Roodgepaald",
  "block.minecraft.banner.half_vertical.white": "Witgepaald",
  "block.minecraft.banner.half_vertical.yellow": "Geelgepaald",
  "block.minecraft.banner.half_vertical_right.black": "Zwart omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.blue": "Blauw omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.brown": "Bruin omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.cyan": "Turquoise omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.gray": "Grijs omgekeerd gebalkt",
  "block.minecraft.banner.half_vertical_right.green": "Gruune per peel omgekeerd",
  "block.minecraft.banner.half_vertical_right.light_blue": "Lichtblauw omgekeerd gebalkt",
  "block.minecraft.banner.half_vertical_right.light_gray": "Lichtgrijs omgekeerd gebalkt",
  "block.minecraft.banner.half_vertical_right.lime": "Lichtgroen omgekeerd gebalkt",
  "block.minecraft.banner.half_vertical_right.magenta": "Magenta omgekeerd gebalkt",
  "block.minecraft.banner.half_vertical_right.orange": "Oranje omgekeerd gebalkt",
  "block.minecraft.banner.half_vertical_right.pink": "Roze omgekeerd gebalkt",
  "block.minecraft.banner.half_vertical_right.purple": "Péérse per peel omgekeerd",
  "block.minecraft.banner.half_vertical_right.red": "Rood omgekeerd gepaald",
  "block.minecraft.banner.half_vertical_right.white": "Wit omgekeerd gebalkt",
  "block.minecraft.banner.half_vertical_right.yellow": "Geel omgekeerd gebalkt",
  "block.minecraft.banner.mojang.black": "Zwart ding",
  "block.minecraft.banner.mojang.blue": "Blauw ding",
  "block.minecraft.banner.mojang.brown": "Bruin ding",
  "block.minecraft.banner.mojang.cyan": "Cyaan ding",
  "block.minecraft.banner.mojang.gray": "Grijs ding",
  "block.minecraft.banner.mojang.green": "Gruun Mojangwapen",
  "block.minecraft.banner.mojang.light_blue": "Lichtblauw ding",
  "block.minecraft.banner.mojang.light_gray": "Lightgrijs ding",
  "block.minecraft.banner.mojang.lime": "Lichtgroen ding",
  "block.minecraft.banner.mojang.magenta": "Magenta ding",
  "block.minecraft.banner.mojang.orange": "Oranje ding",
  "block.minecraft.banner.mojang.pink": "Roze ding",
  "block.minecraft.banner.mojang.purple": "Péérs Mojangwapen",
  "block.minecraft.banner.mojang.red": "Rood ding",
  "block.minecraft.banner.mojang.white": "Wit ding",
  "block.minecraft.banner.mojang.yellow": "Geel ding",
  "block.minecraft.banner.piglin.black": "Blauwe snuit",
  "block.minecraft.banner.piglin.blue": "Lichtgroene snuit",
  "block.minecraft.banner.piglin.brown": "Grijze snuit",
  "block.minecraft.banner.piglin.cyan": "Grijze snuit",
  "block.minecraft.banner.piglin.gray": "Grijze snuit",
  "block.minecraft.banner.piglin.green": "Grijze snuit",
  "block.minecraft.banner.piglin.light_blue": "Lichtblauw kruis",
  "block.minecraft.banner.piglin.light_gray": "Lichtgrijs kruis",
  "block.minecraft.banner.piglin.lime": "Lichtgroene snuit",
  "block.minecraft.banner.piglin.magenta": "Magenta snuit",
  "block.minecraft.banner.piglin.orange": "Oranjese tuter",
  "block.minecraft.banner.piglin.pink": "Lichtgroene snuit",
  "block.minecraft.banner.piglin.purple": "Paarse snuit",
  "block.minecraft.banner.piglin.red": "Rode snuit",
  "block.minecraft.banner.piglin.white": "Wiette tuter",
  "block.minecraft.banner.piglin.yellow": "Gele snuit",
  "block.minecraft.banner.rhombus.black": "Zwarte ruit",
  "block.minecraft.banner.rhombus.blue": "Blauwe ruit",
  "block.minecraft.banner.rhombus.brown": "Bruine ruit",
  "block.minecraft.banner.rhombus.cyan": "Cyaan ruit",
  "block.minecraft.banner.rhombus.gray": "Grijze ruit",
  "block.minecraft.banner.rhombus.green": "Gruune ruit",
  "block.minecraft.banner.rhombus.light_blue": "Lichtblauwe rechterschuinbalk",
  "block.minecraft.banner.rhombus.light_gray": "Lichtgrijze ruit",
  "block.minecraft.banner.rhombus.lime": "Lichtgroene ruit",
  "block.minecraft.banner.rhombus.magenta": "Magenta ruit",
  "block.minecraft.banner.rhombus.orange": "Grijze ruit",
  "block.minecraft.banner.rhombus.pink": "Roze ruit",
  "block.minecraft.banner.rhombus.purple": "Péérse ruit",
  "block.minecraft.banner.rhombus.red": "Rode ruit",
  "block.minecraft.banner.rhombus.white": "Wit lozanje",
  "block.minecraft.banner.rhombus.yellow": "Gele ruit",
  "block.minecraft.banner.skull.black": "Zwarte schedelsymbool",
  "block.minecraft.banner.skull.blue": "Blauw schedelsymbool",
  "block.minecraft.banner.skull.brown": "Bruin schedelsymbool",
  "block.minecraft.banner.skull.cyan": "Cyaan schedelsymbool",
  "block.minecraft.banner.skull.gray": "Grijze schedelsymbool",
  "block.minecraft.banner.skull.green": "Gruun schedelwapen",
  "block.minecraft.banner.skull.light_blue": "Lichtblauw schedelsymbool",
  "block.minecraft.banner.skull.light_gray": "Lichtgrijs schedelsymbool",
  "block.minecraft.banner.skull.lime": "Lichtgroen schedelsymbool",
  "block.minecraft.banner.skull.magenta": "Magenta schedelsymbool",
  "block.minecraft.banner.skull.orange": "Oranje schedelsymbool",
  "block.minecraft.banner.skull.pink": "Roze schedelsymbool",
  "block.minecraft.banner.skull.purple": "Péérs schedelwapen",
  "block.minecraft.banner.skull.red": "Rood schedelsymbool",
  "block.minecraft.banner.skull.white": "Wit schedelsymbool",
  "block.minecraft.banner.skull.yellow": "Geel schedelwapensymbool",
  "block.minecraft.banner.small_stripes.black": "Zwarte strepen",
  "block.minecraft.banner.small_stripes.blue": "Blauwe strepen",
  "block.minecraft.banner.small_stripes.brown": "Bruine strepen",
  "block.minecraft.banner.small_stripes.cyan": "Cyaan strepen",
  "block.minecraft.banner.small_stripes.gray": "Grijze strepen",
  "block.minecraft.banner.small_stripes.green": "Gruune paly",
  "block.minecraft.banner.small_stripes.light_blue": "Lichtblauwe strepen",
  "block.minecraft.banner.small_stripes.light_gray": "Lichtgrijze strepen",
  "block.minecraft.banner.small_stripes.lime": "Lichtgroene strepen",
  "block.minecraft.banner.small_stripes.magenta": "Magenta strepen",
  "block.minecraft.banner.small_stripes.orange": "Oranje strepen",
  "block.minecraft.banner.small_stripes.pink": "Roze strepen",
  "block.minecraft.banner.small_stripes.purple": "Péérse paly",
  "block.minecraft.banner.small_stripes.red": "Rode strepen",
  "block.minecraft.banner.small_stripes.white": "Witte strepen",
  "block.minecraft.banner.small_stripes.yellow": "Gele strepen",
  "block.minecraft.banner.square_bottom_left.black": "Zwart basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.blue": "Blauw kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.brown": "Bruin kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.cyan": "Turquoise kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.gray": "Grijs kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.green": "Grún basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.light_blue": "Lichtblauw kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.light_gray": "Lichtgrijs kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.lime": "Lichtgroen kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenta kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.orange": "Oranje kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.pink": "Roze kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.purple": "Péérs basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.red": "Rooi basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.white": "Wit kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.yellow": "Geel kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_right.black": "Zwart kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.blue": "Blauw kwartier linksonderin",
  "block.minecraft.banner.square_bottom_right.brown": "Bruin kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.cyan": "Cyaan kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.gray": "Grijs kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.green": "Grún basis sinister kanton",
  "block.minecraft.banner.square_bottom_right.light_blue": "Lichtblauw kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.light_gray": "Lichtgrijs kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.lime": "Lichtgroen kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenta kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.orange": "Oranje kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.pink": "Roze kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.purple": "Péérs basis sinister kanton",
  "block.minecraft.banner.square_bottom_right.red": "Rood kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.white": "Wit basis sinister kanton",
  "block.minecraft.banner.square_bottom_right.yellow": "Geel kwartier linksonder",
  "block.minecraft.banner.square_top_left.black": "Zwart hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.blue": "Blauw hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.brown": "Bruin hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.cyan": "Cyaan hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.gray": "Grijs hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.green": "Grún hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.light_blue": "Lichtblauw hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.light_gray": "Lichtgrijs hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.lime": "Lichtgroen hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.magenta": "Magenta hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.orange": "Oranje hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.pink": "Roze hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.purple": "Péérs hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.red": "Rood hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.white": "Wit hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.yellow": "Geel hoofd dexter kanton",
  "block.minecraft.banner.square_top_right.black": "Zwart hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.blue": "Blauw hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.brown": "Bruin hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.cyan": "Cyaan hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.gray": "Grijs hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.green": "Grún hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.light_blue": "Lichtblauw hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.light_gray": "Lichtgrijs hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.lime": "Lichtgroen hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.magenta": "Magenta hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.orange": "Oranje hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.pink": "Roze hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.purple": "Péérs hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.red": "Rood hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.white": "Wit hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.yellow": "Geel hoofd sinister kanton",
  "block.minecraft.banner.straight_cross.black": "Zwart kruis",
  "block.minecraft.banner.straight_cross.blue": "Blauw kruis",
  "block.minecraft.banner.straight_cross.brown": "Bruin kruis",
  "block.minecraft.banner.straight_cross.cyan": "Cyaan kruis",
  "block.minecraft.banner.straight_cross.gray": "Grijs kruis",
  "block.minecraft.banner.straight_cross.green": "Gruun kruis",
  "block.minecraft.banner.straight_cross.light_blue": "Lichtblauw kruis",
  "block.minecraft.banner.straight_cross.light_gray": "Lichtgrijs kruis",
  "block.minecraft.banner.straight_cross.lime": "Lichtgroen kruis",
  "block.minecraft.banner.straight_cross.magenta": "Magenta kruis",
  "block.minecraft.banner.straight_cross.orange": "Oranje kruis",
  "block.minecraft.banner.straight_cross.pink": "Roze kruis",
  "block.minecraft.banner.straight_cross.purple": "Péérs kruis",
  "block.minecraft.banner.straight_cross.red": "Rood kruis",
  "block.minecraft.banner.straight_cross.white": "Wit kruis",
  "block.minecraft.banner.straight_cross.yellow": "Geel kruis",
  "block.minecraft.banner.stripe_bottom.black": "Zwarte basis",
  "block.minecraft.banner.stripe_bottom.blue": "Blauwe basis",
  "block.minecraft.banner.stripe_bottom.brown": "Bruine basis",
  "block.minecraft.banner.stripe_bottom.cyan": "Cyaan Basis",
  "block.minecraft.banner.stripe_bottom.gray": "Grijze basis",
  "block.minecraft.banner.stripe_bottom.green": "Grúne basis",
  "block.minecraft.banner.stripe_bottom.light_blue": "Lichtblauwe basis",
  "block.minecraft.banner.stripe_bottom.light_gray": "Lichtgrijze basis",
  "block.minecraft.banner.stripe_bottom.lime": "Lichtgroene basis",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenta basis",
  "block.minecraft.banner.stripe_bottom.orange": "Oranje basis",
  "block.minecraft.banner.stripe_bottom.pink": "Roze basis",
  "block.minecraft.banner.stripe_bottom.purple": "Péérse basis",
  "block.minecraft.banner.stripe_bottom.red": "Rode basis",
  "block.minecraft.banner.stripe_bottom.white": "Witte basis",
  "block.minecraft.banner.stripe_bottom.yellow": "Gele basis",
  "block.minecraft.banner.stripe_center.black": "Zwarte paal",
  "block.minecraft.banner.stripe_center.blue": "Blauwe paal",
  "block.minecraft.banner.stripe_center.brown": "Bruine paal",
  "block.minecraft.banner.stripe_center.cyan": "Cyaan paal",
  "block.minecraft.banner.stripe_center.gray": "Grijze paal",
  "block.minecraft.banner.stripe_center.green": "Gruune peel",
  "block.minecraft.banner.stripe_center.light_blue": "Lichtblauwe strepen",
  "block.minecraft.banner.stripe_center.light_gray": "Lichtgrijze paal",
  "block.minecraft.banner.stripe_center.lime": "Lichtgroene strepen",
  "block.minecraft.banner.stripe_center.magenta": "Magenta strepen",
  "block.minecraft.banner.stripe_center.orange": "Oranje strepen",
  "block.minecraft.banner.stripe_center.pink": "Roze strepen",
  "block.minecraft.banner.stripe_center.purple": "Péérse peel",
  "block.minecraft.banner.stripe_center.red": "Rode paal",
  "block.minecraft.banner.stripe_center.white": "Witte strepen",
  "block.minecraft.banner.stripe_center.yellow": "Gele strepen",
  "block.minecraft.banner.stripe_downleft.black": "Zwarte linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.blue": "Blauwe linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.brown": "Bruine linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.cyan": "Cyaan linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.gray": "Grijze linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.green": "Gruune band sinister",
  "block.minecraft.banner.stripe_downleft.light_blue": "Lichtblauwe linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.light_gray": "Lichtgrijze linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.lime": "Lichtgroene linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.orange": "Oranje linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.pink": "Roze linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.purple": "Péérse band sinister",
  "block.minecraft.banner.stripe_downleft.red": "Rode linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.white": "Witte linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.yellow": "Gele linkerschuinbalk",
  "block.minecraft.banner.stripe_downright.black": "Zwarte rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.blue": "Blauwe rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.brown": "Bruine rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.cyan": "Cyaan rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.gray": "Grijze rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.green": "Gruune band",
  "block.minecraft.banner.stripe_downright.light_blue": "Lichtblauwe rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.light_gray": "Lichtgrijze rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.lime": "Lichtgroene rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.orange": "Oranje rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.pink": "Roze rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.purple": "Péérse band",
  "block.minecraft.banner.stripe_downright.red": "Rode rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.white": "Witte rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.yellow": "Gele rechterschuinbalk",
  "block.minecraft.banner.stripe_left.black": "Zwarte peel dexter",
  "block.minecraft.banner.stripe_left.blue": "Blauwe paal dexter",
  "block.minecraft.banner.stripe_left.brown": "Bruine paal dexter",
  "block.minecraft.banner.stripe_left.cyan": "Cyaan paal dexter",
  "block.minecraft.banner.stripe_left.gray": "Grijze paal dexter",
  "block.minecraft.banner.stripe_left.green": "Grúne rechterpaal",
  "block.minecraft.banner.stripe_left.light_blue": "Lichtblauwe paal dexter",
  "block.minecraft.banner.stripe_left.light_gray": "Lichtgrijze paal dexter",
  "block.minecraft.banner.stripe_left.lime": "Lichtgroene paal dexter",
  "block.minecraft.banner.stripe_left.magenta": "Magenta paal dexter",
  "block.minecraft.banner.stripe_left.orange": "Oranje paal dexter",
  "block.minecraft.banner.stripe_left.pink": "Roze paal dexter",
  "block.minecraft.banner.stripe_left.purple": "Péérse peel dexter",
  "block.minecraft.banner.stripe_left.red": "Rode paal dexter",
  "block.minecraft.banner.stripe_left.white": "Witte paal dexter",
  "block.minecraft.banner.stripe_left.yellow": "Gele paal dexter",
  "block.minecraft.banner.stripe_middle.black": "Zwarte dwarsbalk",
  "block.minecraft.banner.stripe_middle.blue": "Blauwe dwarsbalk",
  "block.minecraft.banner.stripe_middle.brown": "Bruine dwarsbalk",
  "block.minecraft.banner.stripe_middle.cyan": "Cyaan dwarsbalk",
  "block.minecraft.banner.stripe_middle.gray": "Grijze dwarsbalk",
  "block.minecraft.banner.stripe_middle.green": "Gruune faas",
  "block.minecraft.banner.stripe_middle.light_blue": "Lichtblauwe dwarsbalk",
  "block.minecraft.banner.stripe_middle.light_gray": "Lichtgrijze dwarsbalk",
  "block.minecraft.banner.stripe_middle.lime": "Lichtgroene dwarsbalk",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta dwarsbalk",
  "block.minecraft.banner.stripe_middle.orange": "Oranje dwarsbalk",
  "block.minecraft.banner.stripe_middle.pink": "Roze dwarsbalk",
  "block.minecraft.banner.stripe_middle.purple": "Péérse faas",
  "block.minecraft.banner.stripe_middle.red": "Rode dwarsbalk",
  "block.minecraft.banner.stripe_middle.white": "Witte dwarsbalk",
  "block.minecraft.banner.stripe_middle.yellow": "Gele dwarsbalk",
  "block.minecraft.banner.stripe_right.black": "Zwarte paal sinister",
  "block.minecraft.banner.stripe_right.blue": "Blauwe paal sinister",
  "block.minecraft.banner.stripe_right.brown": "Bruine paal sinister",
  "block.minecraft.banner.stripe_right.cyan": "Cyaan paal sinister",
  "block.minecraft.banner.stripe_right.gray": "Grijze paal sinister",
  "block.minecraft.banner.stripe_right.green": "Gruune peel sinister",
  "block.minecraft.banner.stripe_right.light_blue": "Lichtblauwe paal sinister",
  "block.minecraft.banner.stripe_right.light_gray": "Lichtgrijze paal sinister",
  "block.minecraft.banner.stripe_right.lime": "Lichtgroene paal sinister",
  "block.minecraft.banner.stripe_right.magenta": "Magenta paal sinister",
  "block.minecraft.banner.stripe_right.orange": "Oranje paal sinister",
  "block.minecraft.banner.stripe_right.pink": "Roze paal sinister",
  "block.minecraft.banner.stripe_right.purple": "Péérse peel sinister",
  "block.minecraft.banner.stripe_right.red": "Rode paal sinister",
  "block.minecraft.banner.stripe_right.white": "Witte paal sinister",
  "block.minecraft.banner.stripe_right.yellow": "Gele paal sinister",
  "block.minecraft.banner.stripe_top.black": "Zwarte top",
  "block.minecraft.banner.stripe_top.blue": "Blauwe top",
  "block.minecraft.banner.stripe_top.brown": "Bruine top",
  "block.minecraft.banner.stripe_top.cyan": "Cyaan top",
  "block.minecraft.banner.stripe_top.gray": "Grijze top",
  "block.minecraft.banner.stripe_top.green": "Grúne top",
  "block.minecraft.banner.stripe_top.light_blue": "Lichtblauwe top",
  "block.minecraft.banner.stripe_top.light_gray": "Lichtgrijze top",
  "block.minecraft.banner.stripe_top.lime": "Lichtgroene top",
  "block.minecraft.banner.stripe_top.magenta": "Magenta top",
  "block.minecraft.banner.stripe_top.orange": "Oranje top",
  "block.minecraft.banner.stripe_top.pink": "Roze top",
  "block.minecraft.banner.stripe_top.purple": "Péérse top",
  "block.minecraft.banner.stripe_top.red": "Rode top",
  "block.minecraft.banner.stripe_top.white": "Witte top",
  "block.minecraft.banner.stripe_top.yellow": "Gele top",
  "block.minecraft.banner.triangle_bottom.black": "Zwarte keper",
  "block.minecraft.banner.triangle_bottom.blue": "Blauwe keper",
  "block.minecraft.banner.triangle_bottom.brown": "Bruine keper",
  "block.minecraft.banner.triangle_bottom.cyan": "Cyaan keper",
  "block.minecraft.banner.triangle_bottom.gray": "Grijze keper",
  "block.minecraft.banner.triangle_bottom.green": "Gruune keper",
  "block.minecraft.banner.triangle_bottom.light_blue": "Lichtblauwe keper",
  "block.minecraft.banner.triangle_bottom.light_gray": "Lichtgrijze keper",
  "block.minecraft.banner.triangle_bottom.lime": "Lichtgroene keper",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta keper",
  "block.minecraft.banner.triangle_bottom.orange": "Oranje keper",
  "block.minecraft.banner.triangle_bottom.pink": "Roze keper",
  "block.minecraft.banner.triangle_bottom.purple": "Péérse keper",
  "block.minecraft.banner.triangle_bottom.red": "Rode keper",
  "block.minecraft.banner.triangle_bottom.white": "Witte keper",
  "block.minecraft.banner.triangle_bottom.yellow": "Gele keper",
  "block.minecraft.banner.triangle_top.black": "Zwarte omgekeerde keper",
  "block.minecraft.banner.triangle_top.blue": "Blauwe omgekeerde keper",
  "block.minecraft.banner.triangle_top.brown": "Bruine omgekeerde keper",
  "block.minecraft.banner.triangle_top.cyan": "Cyaan omgekeerde keper",
  "block.minecraft.banner.triangle_top.gray": "Grijze omgekeerde keper",
  "block.minecraft.banner.triangle_top.green": "Gruune omgekeerde keper",
  "block.minecraft.banner.triangle_top.light_blue": "Lichtblauwe omgekeerde keper",
  "block.minecraft.banner.triangle_top.light_gray": "Lichtgrijze omgekeerde keper",
  "block.minecraft.banner.triangle_top.lime": "Lichtgroene omgekeerde keper",
  "block.minecraft.banner.triangle_top.magenta": "Magenta omgekeerde keper",
  "block.minecraft.banner.triangle_top.orange": "Oranje omgekeerde keper",
  "block.minecraft.banner.triangle_top.pink": "Roze omgekeerde keper",
  "block.minecraft.banner.triangle_top.purple": "Péérse omgekeerde keper",
  "block.minecraft.banner.triangle_top.red": "Rode omgekeerde keper",
  "block.minecraft.banner.triangle_top.white": "Witte omgekeerde keper",
  "block.minecraft.banner.triangle_top.yellow": "Gele omgekeerde keper",
  "block.minecraft.banner.triangles_bottom.black": "Zwart-gegolfde basis",
  "block.minecraft.banner.triangles_bottom.blue": "Blauw-gegolfde basis",
  "block.minecraft.banner.triangles_bottom.brown": "Bruin-gegolfde basis",
  "block.minecraft.banner.triangles_bottom.cyan": "Cyaan-gegolfde basis",
  "block.minecraft.banner.triangles_bottom.gray": "Grijs-gegolfde basis",
  "block.minecraft.banner.triangles_bottom.green": "Gruune ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.light_blue": "Lichtblauw-gegolfde basis",
  "block.minecraft.banner.triangles_bottom.light_gray": "Lichtgrijs-gegolfde basis",
  "block.minecraft.banner.triangles_bottom.lime": "Lichtgroen-gegolfde basis",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta-gegolfde basis",
  "block.minecraft.banner.triangles_bottom.orange": "Oranje-gegolfde basis",
  "block.minecraft.banner.triangles_bottom.pink": "Roze-gegolfde basis",
  "block.minecraft.banner.triangles_bottom.purple": "Péérse ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.red": "Rood-gegolfde basis",
  "block.minecraft.banner.triangles_bottom.white": "Wit-gegolfde basis",
  "block.minecraft.banner.triangles_bottom.yellow": "Geel-gegolfde basis",
  "block.minecraft.banner.triangles_top.black": "Zwart-gegolfd hoofd",
  "block.minecraft.banner.triangles_top.blue": "Blauw-gegolfd hoofd",
  "block.minecraft.banner.triangles_top.brown": "Bruin-gegolfd hoofd",
  "block.minecraft.banner.triangles_top.cyan": "Cyaan-gegolfd hoofd",
  "block.minecraft.banner.triangles_top.gray": "Grijs-gegolfd hoofd",
  "block.minecraft.banner.triangles_top.green": "Gruun ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.light_blue": "Lichtblauw-gegolfd hoofd",
  "block.minecraft.banner.triangles_top.light_gray": "Lichtgrijs-gegolfd hoofd",
  "block.minecraft.banner.triangles_top.lime": "Lichtgroen-gegolfd hoofd",
  "block.minecraft.banner.triangles_top.magenta": "Magenta-gegolfd hoofd",
  "block.minecraft.banner.triangles_top.orange": "Oranje-gegolfd hoofd",
  "block.minecraft.banner.triangles_top.pink": "Roze-gegolfd hoofd",
  "block.minecraft.banner.triangles_top.purple": "Péérs ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.red": "Rood-gegolfd hoofd",
  "block.minecraft.banner.triangles_top.white": "Wit-gegolfd hoofd",
  "block.minecraft.banner.triangles_top.yellow": "Geel-gegolfd hoofd",
  "block.minecraft.barrel": "Vaot",
  "block.minecraft.barrier": "Barrière",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Baken",
  "block.minecraft.beacon.primary": "Primaire kracht",
  "block.minecraft.beacon.secondary": "Secundaire kracht",
  "block.minecraft.bed.no_sleep": "Oe kunt allênig 's naachts ofdè tijdes onweer slaope",
  "block.minecraft.bed.not_safe": "Oe kunt naaw nie slaope; d'r zèn monsters in d'n buurt",
  "block.minecraft.bed.obstructed": "Di bed is geblokkeerd",
  "block.minecraft.bed.occupied": "Di bed is bezet",
  "block.minecraft.bed.too_far_away": "Oe kunt naaw nie slaope; ut bed is te ver weg",
  "block.minecraft.bedrock": "Bojemstien",
  "block.minecraft.bee_nest": "Bienest",
  "block.minecraft.beehive": "Biekörref",
  "block.minecraft.beetroots": "Bééte",
  "block.minecraft.bell": "Bel",
  "block.minecraft.big_dripleaf": "Groewt drèùpblad",
  "block.minecraft.big_dripleaf_stem": "Groewte drèùpbladstengel",
  "block.minecraft.birch_button": "Birkehoutere knupke",
  "block.minecraft.birch_door": "Birkehoutere deur",
  "block.minecraft.birch_fence": "Birkehoutere hekke",
  "block.minecraft.birch_fence_gate": "Birkehoutere poewert",
  "block.minecraft.birch_hanging_sign": "Berkenhouten hangbord",
  "block.minecraft.birch_leaves": "Birkebloajer",
  "block.minecraft.birch_log": "Birkestam",
  "block.minecraft.birch_planks": "Birkehoutere plaank",
  "block.minecraft.birch_pressure_plate": "Birkehoutere drôkplôat",
  "block.minecraft.birch_sapling": "Birkekiemplent",
  "block.minecraft.birch_shelf": "Berkenhouten schap",
  "block.minecraft.birch_sign": "Birkehoutere burd",
  "block.minecraft.birch_slab": "Birkehoutere plôat",
  "block.minecraft.birch_stairs": "Birkehoutere trep",
  "block.minecraft.birch_trapdoor": "Birkehoutere vaalluuk",
  "block.minecraft.birch_wall_hanging_sign": "Berkenhouten uithangbord",
  "block.minecraft.birch_wall_sign": "Birkehoutere burd an waand",
  "block.minecraft.birch_wood": "Birkehout",
  "block.minecraft.black_banner": "Zwerte banier",
  "block.minecraft.black_bed": "Zwert bed",
  "block.minecraft.black_candle": "Zwerte kèèrs",
  "block.minecraft.black_candle_cake": "Vloai meej zwerte kèèrs",
  "block.minecraft.black_carpet": "Zwert tapijt",
  "block.minecraft.black_concrete": "Zwert beton",
  "block.minecraft.black_concrete_powder": "Zwert cement",
  "block.minecraft.black_glazed_terracotta": "Zwertgeglaozuurde terracotta",
  "block.minecraft.black_shulker_box": "Zwerte shulkerdoâs",
  "block.minecraft.black_stained_glass": "Zwètgekleurd glaos",
  "block.minecraft.black_stained_glass_pane": "Zwètgekleurde glaoze rute",
  "block.minecraft.black_terracotta": "Zwert terracotta",
  "block.minecraft.black_wool": "Zwerte wól",
  "block.minecraft.blackstone": "Zwertstien",
  "block.minecraft.blackstone_slab": "Zwertstienen plôat",
  "block.minecraft.blackstone_stairs": "Zwertstienen trep",
  "block.minecraft.blackstone_wall": "Zwertstienen waand",
  "block.minecraft.blast_furnace": "Hoègoove",
  "block.minecraft.blue_banner": "Blauwe banier",
  "block.minecraft.blue_bed": "Blaaw bed",
  "block.minecraft.blue_candle": "Blaawe kèèrs",
  "block.minecraft.blue_candle_cake": "Vloai meej blaawe kèèrs",
  "block.minecraft.blue_carpet": "Blaaw tapijt",
  "block.minecraft.blue_concrete": "Blaaw beton",
  "block.minecraft.blue_concrete_powder": "Blaaw cement",
  "block.minecraft.blue_glazed_terracotta": "Blaawgeglaozuurde terracotta",
  "block.minecraft.blue_ice": "Blaaw èès",
  "block.minecraft.blue_orchid": "Blaawe orchidee",
  "block.minecraft.blue_shulker_box": "Blaawe shulkerdoâs",
  "block.minecraft.blue_stained_glass": "Blaawgekleurd glaos",
  "block.minecraft.blue_stained_glass_pane": "Blaawgekleurde glaoze rute",
  "block.minecraft.blue_terracotta": "Blaaw terracotta",
  "block.minecraft.blue_wool": "Blaawe wól",
  "block.minecraft.bone_block": "Bottenblok",
  "block.minecraft.bookshelf": "Buukekast",
  "block.minecraft.brain_coral": "Hersenkoraal",
  "block.minecraft.brain_coral_block": "Hersenkoraalblok",
  "block.minecraft.brain_coral_fan": "Hersenkoraalwaojer",
  "block.minecraft.brain_coral_wall_fan": "Hersenkoraalwaojer an waand",
  "block.minecraft.brewing_stand": "Braawstandoard",
  "block.minecraft.brick_slab": "Bakstiene plôat",
  "block.minecraft.brick_stairs": "Bakstienen trep",
  "block.minecraft.brick_wall": "Bakstienen waand",
  "block.minecraft.bricks": "Bakstienen",
  "block.minecraft.brown_banner": "Bruine banier",
  "block.minecraft.brown_bed": "Brèùn bed",
  "block.minecraft.brown_candle": "Brèùne kèèrs",
  "block.minecraft.brown_candle_cake": "Vloai meej brèùne kèèrs",
  "block.minecraft.brown_carpet": "Brèùn tapijt",
  "block.minecraft.brown_concrete": "Brèùn beton",
  "block.minecraft.brown_concrete_powder": "Brèùn cement",
  "block.minecraft.brown_glazed_terracotta": "Brèùngeglaozuurde terracotta",
  "block.minecraft.brown_mushroom": "Brèùne paddestuul",
  "block.minecraft.brown_mushroom_block": "Brèùn paddestuuleblok",
  "block.minecraft.brown_shulker_box": "Brèùne shulkerdoâs",
  "block.minecraft.brown_stained_glass": "Brèùngekleurd glaos",
  "block.minecraft.brown_stained_glass_pane": "Brèùngekleurde glaoze rute",
  "block.minecraft.brown_terracotta": "Brèùn terracotta",
  "block.minecraft.brown_wool": "Brèùne wól",
  "block.minecraft.bubble_column": "Bellenkolom",
  "block.minecraft.bubble_coral": "Blaaskoraal",
  "block.minecraft.bubble_coral_block": "Blaaskoraalblok",
  "block.minecraft.bubble_coral_fan": "Blaaskoraalwaojer",
  "block.minecraft.bubble_coral_wall_fan": "Blaaskoraalwaojer an waand",
  "block.minecraft.budding_amethyst": "Oitlopende amethist",
  "block.minecraft.bush": "Struik",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Cactusbloem",
  "block.minecraft.cake": "Vloai",
  "block.minecraft.calcite": "Calciet",
  "block.minecraft.calibrated_sculk_sensor": "Gekalibreerde sculksensor",
  "block.minecraft.campfire": "Kampvuurke",
  "block.minecraft.candle": "Kèèrs",
  "block.minecraft.candle_cake": "Vloai meej kèèrs",
  "block.minecraft.carrots": "Peeje",
  "block.minecraft.cartography_table": "Kartograofietoafel",
  "block.minecraft.carved_pumpkin": "Beweirekte pompoen",
  "block.minecraft.cauldron": "Kittel",
  "block.minecraft.cave_air": "Grotlocht",
  "block.minecraft.cave_vines": "Grotteliaone",
  "block.minecraft.cave_vines_plant": "Grotteliaoneplent",
  "block.minecraft.chain": "Ketting",
  "block.minecraft.chain_command_block": "Gekoppeld opdrachtblok",
  "block.minecraft.cherry_button": "Kersenhouten knop",
  "block.minecraft.cherry_door": "Kersenhouten deur",
  "block.minecraft.cherry_fence": "Kersenhouten hek",
  "block.minecraft.cherry_fence_gate": "Kersenhouten poortje",
  "block.minecraft.cherry_hanging_sign": "Kersenhouten hangbord",
  "block.minecraft.cherry_leaves": "Kersenbladeren",
  "block.minecraft.cherry_log": "Kersenboomstam",
  "block.minecraft.cherry_planks": "Kersenhouten planken",
  "block.minecraft.cherry_pressure_plate": "Kersenhouten drukplaat",
  "block.minecraft.cherry_sapling": "Kersenzaailing",
  "block.minecraft.cherry_shelf": "Kersenhouten schap",
  "block.minecraft.cherry_sign": "Kersenhouten bord",
  "block.minecraft.cherry_slab": "Kersenhouten plaat",
  "block.minecraft.cherry_stairs": "Kersenhouten trap",
  "block.minecraft.cherry_trapdoor": "Kersenhouten valluik",
  "block.minecraft.cherry_wall_hanging_sign": "Kersenhouten uithangbord",
  "block.minecraft.cherry_wall_sign": "Kersenhouten bord aan muur",
  "block.minecraft.cherry_wood": "Kersenhout",
  "block.minecraft.chest": "Kiest",
  "block.minecraft.chipped_anvil": "Gebarsten ònbild",
  "block.minecraft.chiseled_bookshelf": "Bewerkte boekenkast",
  "block.minecraft.chiseled_copper": "Bewerkt koperblok",
  "block.minecraft.chiseled_deepslate": "Gebèèteld wrevelstien",
  "block.minecraft.chiseled_nether_bricks": "Gebeitelde Netherbakstienen",
  "block.minecraft.chiseled_polished_blackstone": "Gebeiteld gepolèèst zwertstien",
  "block.minecraft.chiseled_quartz_block": "Gebeiteld kwertsblok",
  "block.minecraft.chiseled_red_sandstone": "Gebeiteld rooi zaandstien",
  "block.minecraft.chiseled_resin_bricks": "Gebeitelde harsbakstenen",
  "block.minecraft.chiseled_sandstone": "Gebeiteld zaandstien",
  "block.minecraft.chiseled_stone_bricks": "Gebeitelde blokstienen",
  "block.minecraft.chiseled_tuff": "Gebeiteld tufsteen",
  "block.minecraft.chiseled_tuff_bricks": "Gebeitelde tufstenen blokstenen",
  "block.minecraft.chorus_flower": "Chorusbluumke",
  "block.minecraft.chorus_plant": "Chorusplent",
  "block.minecraft.clay": "Klaai",
  "block.minecraft.closed_eyeblossom": "Gesloten gluurbloesem",
  "block.minecraft.coal_block": "Stienkôolblok",
  "block.minecraft.coal_ore": "Steenkoolerts",
  "block.minecraft.coarse_dirt": "Groeve èèrde",
  "block.minecraft.cobbled_deepslate": "Geplavèèd wrevelstien",
  "block.minecraft.cobbled_deepslate_slab": "Geplavèède wrevelstienen plôat",
  "block.minecraft.cobbled_deepslate_stairs": "Geplavèède wrevelstienen trep",
  "block.minecraft.cobbled_deepslate_wall": "Geplavèède wrevelstienen waand",
  "block.minecraft.cobblestone": "Kaaistien",
  "block.minecraft.cobblestone_slab": "Keistienen plôat",
  "block.minecraft.cobblestone_stairs": "Keistienen trep",
  "block.minecraft.cobblestone_wall": "Keistienen waand",
  "block.minecraft.cobweb": "Spiennekoppenet",
  "block.minecraft.cocoa": "Cacao",
  "block.minecraft.command_block": "Opdrachtblok",
  "block.minecraft.comparator": "Redstonevergelééker",
  "block.minecraft.composter": "Compostbak",
  "block.minecraft.conduit": "Kanaal",
  "block.minecraft.copper_bars": "Koperen tralies",
  "block.minecraft.copper_block": "Koperblok",
  "block.minecraft.copper_bulb": "Koperen lamp",
  "block.minecraft.copper_chain": "Koperen ketting",
  "block.minecraft.copper_chest": "Koperen kist",
  "block.minecraft.copper_door": "Koperen deur",
  "block.minecraft.copper_golem_statue": "Kopergolemstandbeeld",
  "block.minecraft.copper_grate": "Koperen rooster",
  "block.minecraft.copper_lantern": "Koperen lantaarn",
  "block.minecraft.copper_ore": "Kopererts",
  "block.minecraft.copper_torch": "Koperfakkel",
  "block.minecraft.copper_trapdoor": "Koperen valluik",
  "block.minecraft.copper_wall_torch": "Koperfakkel aan muur",
  "block.minecraft.cornflower": "Kollebluumke",
  "block.minecraft.cracked_deepslate_bricks": "Gebarste wrevelblokstienen",
  "block.minecraft.cracked_deepslate_tiles": "Gebarste wrevelstienen tegels",
  "block.minecraft.cracked_nether_bricks": "Gebarste Netherbakstienen",
  "block.minecraft.cracked_polished_blackstone_bricks": "Gebeiteld gepolèèst zwertstienen blokstienen",
  "block.minecraft.cracked_stone_bricks": "Gebarsten blokstienen",
  "block.minecraft.crafter": "Vervaardigingsmachine",
  "block.minecraft.crafting_table": "Weirekbaank",
  "block.minecraft.creaking_heart": "Schorswakerhart",
  "block.minecraft.creeper_head": "Creeperhoofd",
  "block.minecraft.creeper_wall_head": "Creeperhoofd an waand",
  "block.minecraft.crimson_button": "Helrôoje houtere knupke",
  "block.minecraft.crimson_door": "Helrôoje houtere deur",
  "block.minecraft.crimson_fence": "Helrôoje houtere hekke",
  "block.minecraft.crimson_fence_gate": "Helrôoje houtere poewert",
  "block.minecraft.crimson_fungus": "Helrôoje zwam",
  "block.minecraft.crimson_hanging_sign": "Helrood houten hangbord",
  "block.minecraft.crimson_hyphae": "Helrôoje schimmeldraoj",
  "block.minecraft.crimson_nylium": "Helrôoje nylium",
  "block.minecraft.crimson_planks": "Helrôoje houtere plaank",
  "block.minecraft.crimson_pressure_plate": "Helrôoje houtere drôkplôat",
  "block.minecraft.crimson_roots": "Helrôoje peeje",
  "block.minecraft.crimson_shelf": "Helrood houten schap",
  "block.minecraft.crimson_sign": "Helrôoje houtere burd",
  "block.minecraft.crimson_slab": "Helrôoje houtere plôat",
  "block.minecraft.crimson_stairs": "Helrôoje houtere trep",
  "block.minecraft.crimson_stem": "Helrôoje stam",
  "block.minecraft.crimson_trapdoor": "Helrôoje houtere vaalluuk",
  "block.minecraft.crimson_wall_hanging_sign": "Helrood houten uithangbord",
  "block.minecraft.crimson_wall_sign": "Helrôoje houtere burd an waand",
  "block.minecraft.crying_obsidian": "Jankend obsidiaan",
  "block.minecraft.cut_copper": "Gesneje koperblok",
  "block.minecraft.cut_copper_slab": "Gesneje kopere plôat",
  "block.minecraft.cut_copper_stairs": "Gesneje kopere trep",
  "block.minecraft.cut_red_sandstone": "Gesneeje rooi zaandstien",
  "block.minecraft.cut_red_sandstone_slab": "Gesneeje rooie zaandstienen plôat",
  "block.minecraft.cut_sandstone": "Gesneeje zaandstien",
  "block.minecraft.cut_sandstone_slab": "Gesneeje zaandstienen plôat",
  "block.minecraft.cyan_banner": "Turquoise banier",
  "block.minecraft.cyan_bed": "Turquoise bed",
  "block.minecraft.cyan_candle": "Turquoise kèèrs",
  "block.minecraft.cyan_candle_cake": "Vloai meej turquoise kèèrs",
  "block.minecraft.cyan_carpet": "Turquoise tapijt",
  "block.minecraft.cyan_concrete": "Turquoise beton",
  "block.minecraft.cyan_concrete_powder": "Turquoise cement",
  "block.minecraft.cyan_glazed_terracotta": "Turquoisegeglaozuurde terracotta",
  "block.minecraft.cyan_shulker_box": "Turquoise shulkerdoâs",
  "block.minecraft.cyan_stained_glass": "Turquoisegekleurd glaos",
  "block.minecraft.cyan_stained_glass_pane": "Cyaangekleurde glaoze rute",
  "block.minecraft.cyan_terracotta": "Turquoise terracotta",
  "block.minecraft.cyan_wool": "Turquoise wól",
  "block.minecraft.damaged_anvil": "Beschaodegd ònbild",
  "block.minecraft.dandelion": "Pèèrdublom",
  "block.minecraft.dark_oak_button": "Doenkerèèkehoutere knupke",
  "block.minecraft.dark_oak_door": "Doenkerèèkehoutere deur",
  "block.minecraft.dark_oak_fence": "Doenkerèèkehoutere hekke",
  "block.minecraft.dark_oak_fence_gate": "Doenkerèèkehoutere poewert",
  "block.minecraft.dark_oak_hanging_sign": "Donker eikenhouten hangbord",
  "block.minecraft.dark_oak_leaves": "Doenkerèèkebloajer",
  "block.minecraft.dark_oak_log": "Doenkerèèkestam",
  "block.minecraft.dark_oak_planks": "Doenkerèèkehoutere plaank",
  "block.minecraft.dark_oak_pressure_plate": "Doenkerèèkehoutere drôkplôat",
  "block.minecraft.dark_oak_sapling": "Doenkerèèkekiemplent",
  "block.minecraft.dark_oak_shelf": "Donker eikenhouten schap",
  "block.minecraft.dark_oak_sign": "Doenkerèèkehoutere burd",
  "block.minecraft.dark_oak_slab": "Doenkerèèkehoutere plôat",
  "block.minecraft.dark_oak_stairs": "Doenkerèèkehoutere trep",
  "block.minecraft.dark_oak_trapdoor": "Doenkerèèkehoutere vaalluuk",
  "block.minecraft.dark_oak_wall_hanging_sign": "Donker eikenhouten uithangbord",
  "block.minecraft.dark_oak_wall_sign": "Doenkerèèkehoutere burd an waand",
  "block.minecraft.dark_oak_wood": "Doenkerèèkehout",
  "block.minecraft.dark_prismarine": "Doenkerprismarien",
  "block.minecraft.dark_prismarine_slab": "Doenkerprismarienplôat",
  "block.minecraft.dark_prismarine_stairs": "Doenkerprismarientrep",
  "block.minecraft.daylight_detector": "Daogliechtsensor",
  "block.minecraft.dead_brain_coral": "Dooi hersenkoraal",
  "block.minecraft.dead_brain_coral_block": "Dooi hersenkoraalblok",
  "block.minecraft.dead_brain_coral_fan": "Dooie hersenkoraalwaojer",
  "block.minecraft.dead_brain_coral_wall_fan": "Dooie hersenkoraalwaojer an waand",
  "block.minecraft.dead_bubble_coral": "Dooi bubbelkoraal",
  "block.minecraft.dead_bubble_coral_block": "Dooi blaaskoraalblok",
  "block.minecraft.dead_bubble_coral_fan": "Dooie blaaskoraalwaojer",
  "block.minecraft.dead_bubble_coral_wall_fan": "Dooie blaaskoraalwaojer an waand",
  "block.minecraft.dead_bush": "Dooie struuk",
  "block.minecraft.dead_fire_coral": "Dôot vuurkanaal",
  "block.minecraft.dead_fire_coral_block": "Dôot brandkoraalblok",
  "block.minecraft.dead_fire_coral_fan": "Dôde brandkoraalwaaier",
  "block.minecraft.dead_fire_coral_wall_fan": "Dooie brandkoraalwaojer an waand",
  "block.minecraft.dead_horn_coral": "Dooi hoornkoraal",
  "block.minecraft.dead_horn_coral_block": "Dooi hoornkoraalblok",
  "block.minecraft.dead_horn_coral_fan": "Dooie hoornkoraalwaojer",
  "block.minecraft.dead_horn_coral_wall_fan": "Dooie hoornkoraalwaojer an waand",
  "block.minecraft.dead_tube_coral": "Dooi buiskoraal",
  "block.minecraft.dead_tube_coral_block": "Dooi buiskoraalblok",
  "block.minecraft.dead_tube_coral_fan": "Dooie buiskoraalwaojer",
  "block.minecraft.dead_tube_coral_wall_fan": "Dooie buiskoraalwaojer an waand",
  "block.minecraft.decorated_pot": "Versierde pot",
  "block.minecraft.deepslate": "Wrevelstien",
  "block.minecraft.deepslate_brick_slab": "Wrevelblokstienen plôat",
  "block.minecraft.deepslate_brick_stairs": "Wrevelblokstienen trep",
  "block.minecraft.deepslate_brick_wall": "Wrevelblokstienen waand",
  "block.minecraft.deepslate_bricks": "Wrevelblokstienen",
  "block.minecraft.deepslate_coal_ore": "Wrevelstien-stienkoolerts",
  "block.minecraft.deepslate_copper_ore": "Wrevelstienkopererts",
  "block.minecraft.deepslate_diamond_ore": "Wrevelstiendiamanterts",
  "block.minecraft.deepslate_emerald_ore": "Wrevelstiensmaragderts",
  "block.minecraft.deepslate_gold_ore": "Wrevelstiengawterts",
  "block.minecraft.deepslate_iron_ore": "Wrevelstienèèzererts",
  "block.minecraft.deepslate_lapis_ore": "Wrevelstienlapislazuli-erts",
  "block.minecraft.deepslate_redstone_ore": "Wrevelstienredstone-erts",
  "block.minecraft.deepslate_tile_slab": "Wrevelstienen tegelplôat",
  "block.minecraft.deepslate_tile_stairs": "Wrevelstienen tegeltrep",
  "block.minecraft.deepslate_tile_wall": "Wrevelstienen tegelwaand",
  "block.minecraft.deepslate_tiles": "Wrevelstienen tegels",
  "block.minecraft.detector_rail": "Detectierels",
  "block.minecraft.diamond_block": "Diamantblok",
  "block.minecraft.diamond_ore": "Diamanterts",
  "block.minecraft.diorite": "Dioriet",
  "block.minecraft.diorite_slab": "Diorietplôat",
  "block.minecraft.diorite_stairs": "Dioriettrep",
  "block.minecraft.diorite_wall": "Diorietwaand",
  "block.minecraft.dirt": "Èèrde",
  "block.minecraft.dirt_path": "Èèrdepad",
  "block.minecraft.dispenser": "Dispenser",
  "block.minecraft.dragon_egg": "Draokenaaike",
  "block.minecraft.dragon_head": "Draokenhoofd",
  "block.minecraft.dragon_wall_head": "Draokenhoofd an waand",
  "block.minecraft.dried_ghast": "Uitgedroogde Ghast",
  "block.minecraft.dried_kelp_block": "Gedrêûgd kelpblok",
  "block.minecraft.dripstone_block": "Drèùpstienblok",
  "block.minecraft.dropper": "Dropper",
  "block.minecraft.emerald_block": "Smaragdblok",
  "block.minecraft.emerald_ore": "Smaragderts",
  "block.minecraft.enchanting_table": "Betoveringstoafel",
  "block.minecraft.end_gateway": "Endtoegangspertaol",
  "block.minecraft.end_portal": "Endpertaol",
  "block.minecraft.end_portal_frame": "Endpertaolframe",
  "block.minecraft.end_rod": "Endstaf",
  "block.minecraft.end_stone": "Endstien",
  "block.minecraft.end_stone_brick_slab": "Endblokstienen plôat",
  "block.minecraft.end_stone_brick_stairs": "Endblokstienen trep",
  "block.minecraft.end_stone_brick_wall": "Endblokstienen waand",
  "block.minecraft.end_stone_bricks": "Endblokstienen",
  "block.minecraft.ender_chest": "Enderkiest",
  "block.minecraft.exposed_chiseled_copper": "Blootgesteld bewerkt koperblok",
  "block.minecraft.exposed_copper": "Blootgesteld koperblok",
  "block.minecraft.exposed_copper_bars": "Blootgestelde koperen tralies",
  "block.minecraft.exposed_copper_bulb": "Blootgestelde koperen lamp",
  "block.minecraft.exposed_copper_chain": "Blootgestelde koperen ketting",
  "block.minecraft.exposed_copper_chest": "Blootgestelde koperen kist",
  "block.minecraft.exposed_copper_door": "Blootgestelde koperen deur",
  "block.minecraft.exposed_copper_golem_statue": "Blootgesteld kopergolemstandbeeld",
  "block.minecraft.exposed_copper_grate": "Blootgesteld koperen rooster",
  "block.minecraft.exposed_copper_lantern": "Blootgestelde koperen lantaarn",
  "block.minecraft.exposed_copper_trapdoor": "Blootgesteld koperen valluik",
  "block.minecraft.exposed_cut_copper": "Blootgesteld gesneje koperblok",
  "block.minecraft.exposed_cut_copper_slab": "Blootgestelde gesneje kopere plôat",
  "block.minecraft.exposed_cut_copper_stairs": "Bootgestelde gesneje kopere trep",
  "block.minecraft.exposed_lightning_rod": "Blootgestelde bliksemafleider",
  "block.minecraft.farmland": "Laandbaawèèrde",
  "block.minecraft.fern": "Varen",
  "block.minecraft.fire": "Vuurke",
  "block.minecraft.fire_coral": "Brandkoraal",
  "block.minecraft.fire_coral_block": "Brandkoraalblok",
  "block.minecraft.fire_coral_fan": "Brandkoraalwaaier",
  "block.minecraft.fire_coral_wall_fan": "Brandkoraalwaojer an waand",
  "block.minecraft.firefly_bush": "Vuurvliegjesstruik",
  "block.minecraft.fletching_table": "Bevederingstoafel",
  "block.minecraft.flower_pot": "Blommuhpot",
  "block.minecraft.flowering_azalea": "Bloeiende azalea",
  "block.minecraft.flowering_azalea_leaves": "Bloeiende azaleabloajer",
  "block.minecraft.frogspawn": "Kikkerdril",
  "block.minecraft.frosted_ice": "Gerijpt èès",
  "block.minecraft.furnace": "Oove",
  "block.minecraft.gilded_blackstone": "Verguld zwertstien",
  "block.minecraft.glass": "Glaos",
  "block.minecraft.glass_pane": "Glaoze rute",
  "block.minecraft.glow_lichen": "Glooiend korstmos",
  "block.minecraft.glowstone": "Gleujstien",
  "block.minecraft.gold_block": "Gawtblok",
  "block.minecraft.gold_ore": "Gawterts",
  "block.minecraft.golden_dandelion": "Gouden paardenbloem",
  "block.minecraft.granite": "Graniet",
  "block.minecraft.granite_slab": "Granietplôat",
  "block.minecraft.granite_stairs": "Graniettrep",
  "block.minecraft.granite_wall": "Granietwaand",
  "block.minecraft.grass": "Hoeg graas",
  "block.minecraft.grass_block": "Graasblok",
  "block.minecraft.gravel": "Grind",
  "block.minecraft.gray_banner": "Grijze banier",
  "block.minecraft.gray_bed": "Grèès bed",
  "block.minecraft.gray_candle": "Grèèze kèèrs",
  "block.minecraft.gray_candle_cake": "Vloai meej grèèze kèèrs",
  "block.minecraft.gray_carpet": "Grèès tapijt",
  "block.minecraft.gray_concrete": "Grèès beton",
  "block.minecraft.gray_concrete_powder": "Grèès cement",
  "block.minecraft.gray_glazed_terracotta": "Grèèsgeglaozuurde terracotta",
  "block.minecraft.gray_shulker_box": "Grèèze shulkerdoâs",
  "block.minecraft.gray_stained_glass": "Grèèsgekleurd glaos",
  "block.minecraft.gray_stained_glass_pane": "Grèèsgekleurde glaoze rute",
  "block.minecraft.gray_terracotta": "Grèès terracotta",
  "block.minecraft.gray_wool": "Grèèze wól",
  "block.minecraft.green_banner": "Grúne banier",
  "block.minecraft.green_bed": "Grún bed",
  "block.minecraft.green_candle": "Grúne kèèrs",
  "block.minecraft.green_candle_cake": "Vloai meej grúne kèèrs",
  "block.minecraft.green_carpet": "Grún tapijt",
  "block.minecraft.green_concrete": "Grún beton",
  "block.minecraft.green_concrete_powder": "Grún cement",
  "block.minecraft.green_glazed_terracotta": "Grúngeglaozuurde terracotta",
  "block.minecraft.green_shulker_box": "Grúne shulkerdoâs",
  "block.minecraft.green_stained_glass": "Grúngekleurd glaos",
  "block.minecraft.green_stained_glass_pane": "Grúngekleurde glaoze rute",
  "block.minecraft.green_terracotta": "Grún terracotta",
  "block.minecraft.green_wool": "Grúne wól",
  "block.minecraft.grindstone": "Slèèpstien",
  "block.minecraft.hanging_roots": "Hangende peej'n",
  "block.minecraft.hay_block": "Hôojbaol",
  "block.minecraft.heavy_core": "Zware kern",
  "block.minecraft.heavy_weighted_pressure_plate": "Zwaore drôkgevoelège plôat",
  "block.minecraft.honey_block": "Hoennekblok",
  "block.minecraft.honeycomb_block": "Hoennekgroatblok",
  "block.minecraft.hopper": "Trefter",
  "block.minecraft.horn_coral": "Hoornkoraal",
  "block.minecraft.horn_coral_block": "Hoornkoraalblok",
  "block.minecraft.horn_coral_fan": "Hoornkoraalwaojer",
  "block.minecraft.horn_coral_wall_fan": "Hoornkoraalwaojer an waand",
  "block.minecraft.ice": "Èès",
  "block.minecraft.infested_chiseled_stone_bricks": "Geïnfecteerde gebeitelde blokstienen",
  "block.minecraft.infested_cobblestone": "Geïnfecteerde keistien",
  "block.minecraft.infested_cracked_stone_bricks": "Geïnfecteerde gebarsten blokstienen",
  "block.minecraft.infested_deepslate": "Geïnfecteerd wrevelstien",
  "block.minecraft.infested_mossy_stone_bricks": "Geïnfecteerde mossige blokstienen",
  "block.minecraft.infested_stone": "Geïnfecteerde stien",
  "block.minecraft.infested_stone_bricks": "Geïnfecteerde blokstienen",
  "block.minecraft.iron_bars": "Traolies",
  "block.minecraft.iron_block": "Èèzerblok",
  "block.minecraft.iron_chain": "IJzeren ketting",
  "block.minecraft.iron_door": "Èèzere deur",
  "block.minecraft.iron_ore": "Èèzererts",
  "block.minecraft.iron_trapdoor": "Èèzere vaalluuk",
  "block.minecraft.jack_o_lantern": "Jack-o'-lantern",
  "block.minecraft.jigsaw": "Puzzelblok",
  "block.minecraft.jukebox": "Ploatenspeuler",
  "block.minecraft.jungle_button": "Oerwoudhoutere knupke",
  "block.minecraft.jungle_door": "Oerwoudhoutere deur",
  "block.minecraft.jungle_fence": "Oerwoudhoutere hekke",
  "block.minecraft.jungle_fence_gate": "Oerwoudhoutere poewert",
  "block.minecraft.jungle_hanging_sign": "Oerwoudhouten hangbord",
  "block.minecraft.jungle_leaves": "Oerwoudblaojer",
  "block.minecraft.jungle_log": "Oerwoudstam",
  "block.minecraft.jungle_planks": "Oerwoudhoutere plaank",
  "block.minecraft.jungle_pressure_plate": "Oerwoudhoutere drôkplôat",
  "block.minecraft.jungle_sapling": "Oerwoudkiemplent",
  "block.minecraft.jungle_shelf": "Oerwoudhouten schap",
  "block.minecraft.jungle_sign": "Oerwoudhoutere burd",
  "block.minecraft.jungle_slab": "Oerwoudhoutere plôat",
  "block.minecraft.jungle_stairs": "Oerwoudhoutere trep",
  "block.minecraft.jungle_trapdoor": "Oerwoudhoutere vaalluuk",
  "block.minecraft.jungle_wall_hanging_sign": "Oerwoudhouten uithangbord",
  "block.minecraft.jungle_wall_sign": "Oerwoudhoutere burd an waand",
  "block.minecraft.jungle_wood": "Oerwoudhout",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Kelpplent",
  "block.minecraft.ladder": "Lière",
  "block.minecraft.lantern": "Lantèère",
  "block.minecraft.lapis_block": "Lapislazuliblok",
  "block.minecraft.lapis_ore": "Lapis lazuli-erts",
  "block.minecraft.large_amethyst_bud": "Groewte amethistknup",
  "block.minecraft.large_fern": "Groewte varen",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lavakittel",
  "block.minecraft.leaf_litter": "Dode bladeren",
  "block.minecraft.lectern": "Lessenaor",
  "block.minecraft.lever": "Hendel",
  "block.minecraft.light": "Liecht",
  "block.minecraft.light_blue_banner": "Lichtblauwe banier",
  "block.minecraft.light_blue_bed": "Liechtblaaw bed",
  "block.minecraft.light_blue_candle": "Liechtblaawe kèèrs",
  "block.minecraft.light_blue_candle_cake": "Vloai meej liechtblaawe kèèrs",
  "block.minecraft.light_blue_carpet": "Liechtblaaw tapijt",
  "block.minecraft.light_blue_concrete": "Liechtblaaw beton",
  "block.minecraft.light_blue_concrete_powder": "Liechtblaaw cement",
  "block.minecraft.light_blue_glazed_terracotta": "Liechtblaawgeglaozuurde terracotta",
  "block.minecraft.light_blue_shulker_box": "Liechtblaawe shulkerdoâs",
  "block.minecraft.light_blue_stained_glass": "Liechtblaawgekleurd glaos",
  "block.minecraft.light_blue_stained_glass_pane": "Liechtblaawgekleurde glaoze rute",
  "block.minecraft.light_blue_terracotta": "Liechtblaaw terracotta",
  "block.minecraft.light_blue_wool": "Liechtblaawe wól",
  "block.minecraft.light_gray_banner": "Lichtgrijze banier",
  "block.minecraft.light_gray_bed": "Liechtgrèès bed",
  "block.minecraft.light_gray_candle": "Liechtgrèèze kèèrs",
  "block.minecraft.light_gray_candle_cake": "Vloai meej liechtgrèèze kèèrs",
  "block.minecraft.light_gray_carpet": "Liechtgrèès tapijt",
  "block.minecraft.light_gray_concrete": "Liechtgrèès beton",
  "block.minecraft.light_gray_concrete_powder": "Liechtgrèès cement",
  "block.minecraft.light_gray_glazed_terracotta": "Liechtgrèèsgeglaozuurde terracotta",
  "block.minecraft.light_gray_shulker_box": "Liechtgrèèze shulkerdoâs",
  "block.minecraft.light_gray_stained_glass": "Liechtgrèèsgekleurd glaos",
  "block.minecraft.light_gray_stained_glass_pane": "Liechtgrèèsgekleurde glaoze rute",
  "block.minecraft.light_gray_terracotta": "Liechtgrèès terracotta",
  "block.minecraft.light_gray_wool": "Liechtgrèèze wól",
  "block.minecraft.light_weighted_pressure_plate": "Liechte drôkgevoelège plôat",
  "block.minecraft.lightning_rod": "Wirligtaflèèder",
  "block.minecraft.lilac": "Sering",
  "block.minecraft.lily_of_the_valley": "Lelietje-van-dalen",
  "block.minecraft.lily_pad": "Woaturlelie",
  "block.minecraft.lime_banner": "Lichtgroene banier",
  "block.minecraft.lime_bed": "Liechtgrún bed",
  "block.minecraft.lime_candle": "Liechtgrúne kèèrs",
  "block.minecraft.lime_candle_cake": "Vloai meej liechtgrúne kèèrs",
  "block.minecraft.lime_carpet": "Liechtgrún tapijt",
  "block.minecraft.lime_concrete": "Liechtgrún beton",
  "block.minecraft.lime_concrete_powder": "Liechtgrún cement",
  "block.minecraft.lime_glazed_terracotta": "Liechtgrúngeglaozuurde terracotta",
  "block.minecraft.lime_shulker_box": "Liechtgrúne shulkerdoâs",
  "block.minecraft.lime_stained_glass": "Liechtgrúngekleurd glaos",
  "block.minecraft.lime_stained_glass_pane": "Liechtgrúngekleurde glaoze rute",
  "block.minecraft.lime_terracotta": "Liechtgrún terracotta",
  "block.minecraft.lime_wool": "Liechtgrúne wól",
  "block.minecraft.lodestone": "Zèèlstien",
  "block.minecraft.loom": "Weefgetouw",
  "block.minecraft.magenta_banner": "Magenta banier",
  "block.minecraft.magenta_bed": "Magenta bed",
  "block.minecraft.magenta_candle": "Magenta kèèrs",
  "block.minecraft.magenta_candle_cake": "Vloai meej magenta kèèrs",
  "block.minecraft.magenta_carpet": "Magenta tapijt",
  "block.minecraft.magenta_concrete": "Magenta beton",
  "block.minecraft.magenta_concrete_powder": "Magenta cement",
  "block.minecraft.magenta_glazed_terracotta": "Magentageglaozuurde terracotta",
  "block.minecraft.magenta_shulker_box": "Magenta shulkerdoâs",
  "block.minecraft.magenta_stained_glass": "Magentagekleurd glaos",
  "block.minecraft.magenta_stained_glass_pane": "Magentagekleurde glaoze rute",
  "block.minecraft.magenta_terracotta": "Magenta terracotta",
  "block.minecraft.magenta_wool": "Magenta wól",
  "block.minecraft.magma_block": "Magmablok",
  "block.minecraft.mangrove_button": "Mangrovehouten knop",
  "block.minecraft.mangrove_door": "Mangrovehouten deur",
  "block.minecraft.mangrove_fence": "Mangrovehouten hek",
  "block.minecraft.mangrove_fence_gate": "Mangrovehouten poort",
  "block.minecraft.mangrove_hanging_sign": "Mangrovehouten hangbord",
  "block.minecraft.mangrove_leaves": "Mangrovebladeren",
  "block.minecraft.mangrove_log": "Mangrovestam",
  "block.minecraft.mangrove_planks": "Mangrovehouten planken",
  "block.minecraft.mangrove_pressure_plate": "Mangrovehouten drukplaat",
  "block.minecraft.mangrove_propagule": "Mangrovebroedknop",
  "block.minecraft.mangrove_roots": "Mangrovewortels",
  "block.minecraft.mangrove_shelf": "Mangrovehouten schap",
  "block.minecraft.mangrove_sign": "Mangrovehouten bord",
  "block.minecraft.mangrove_slab": "Mangrovehouten plaat",
  "block.minecraft.mangrove_stairs": "Mangrovehouten trap",
  "block.minecraft.mangrove_trapdoor": "Mangrovehouten valluik",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrovehouten uithangbord",
  "block.minecraft.mangrove_wall_sign": "Mangrovehouten bord aan muur",
  "block.minecraft.mangrove_wood": "Mangrovehout",
  "block.minecraft.medium_amethyst_bud": "Middelgrpewte amethistknup",
  "block.minecraft.melon": "Meloenschèèf",
  "block.minecraft.melon_stem": "Meloenstam",
  "block.minecraft.moss_block": "Mosblok",
  "block.minecraft.moss_carpet": "Mostepèèt",
  "block.minecraft.mossy_cobblestone": "Mossige keistien",
  "block.minecraft.mossy_cobblestone_slab": "Mossige keistienen plôat",
  "block.minecraft.mossy_cobblestone_stairs": "Mossige keistienen trep",
  "block.minecraft.mossy_cobblestone_wall": "Mossige keistienen waand",
  "block.minecraft.mossy_stone_brick_slab": "Mossige blokstienen plôat",
  "block.minecraft.mossy_stone_brick_stairs": "Mossige blokstienen trep",
  "block.minecraft.mossy_stone_brick_wall": "Mossige blokstienen waand",
  "block.minecraft.mossy_stone_bricks": "Mossige blokstienen",
  "block.minecraft.moving_piston": "Bewegende zúúger",
  "block.minecraft.mud": "Modder",
  "block.minecraft.mud_brick_slab": "Modderstenen plaat",
  "block.minecraft.mud_brick_stairs": "Modderstenen trap",
  "block.minecraft.mud_brick_wall": "Modderstenen muur",
  "block.minecraft.mud_bricks": "Modderstenen",
  "block.minecraft.muddy_mangrove_roots": "Modderige mangrovewortels",
  "block.minecraft.mushroom_stem": "Paddestuulestam",
  "block.minecraft.mycelium": "Zwamvlok",
  "block.minecraft.nether_brick_fence": "Netherbakstienen hekke",
  "block.minecraft.nether_brick_slab": "Netherbakstienen plôat",
  "block.minecraft.nether_brick_stairs": "Netherbakstienen trep",
  "block.minecraft.nether_brick_wall": "Netherbakstienen waand",
  "block.minecraft.nether_bricks": "Netherbakstienen",
  "block.minecraft.nether_gold_ore": "Nethergawterts",
  "block.minecraft.nether_portal": "Netherpertaol",
  "block.minecraft.nether_quartz_ore": "Netherkwertserts",
  "block.minecraft.nether_sprouts": "Netherscheuten",
  "block.minecraft.nether_wart": "Netherkrèùd",
  "block.minecraft.nether_wart_block": "Netherkrèùdblok",
  "block.minecraft.netherite_block": "Netherietblok",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Nootblok",
  "block.minecraft.oak_button": "Èèkehoutere knupke",
  "block.minecraft.oak_door": "Èèkehoutere deur",
  "block.minecraft.oak_fence": "Èèkehoutere hekke",
  "block.minecraft.oak_fence_gate": "Èèkehoutere poewert",
  "block.minecraft.oak_hanging_sign": "Eikenhouten hangbord",
  "block.minecraft.oak_leaves": "Èèkebloajer",
  "block.minecraft.oak_log": "Èèkestam",
  "block.minecraft.oak_planks": "Èèkehoutere plaank",
  "block.minecraft.oak_pressure_plate": "Èèkehoutere drôkplôat",
  "block.minecraft.oak_sapling": "Èèkekiemplent",
  "block.minecraft.oak_shelf": "Eikenhouten schap",
  "block.minecraft.oak_sign": "Èèkehoutere burd",
  "block.minecraft.oak_slab": "Èèkehoutere plôat",
  "block.minecraft.oak_stairs": "Èèkehoutere trep",
  "block.minecraft.oak_trapdoor": "Èèkehoutere vaalluuk",
  "block.minecraft.oak_wall_hanging_sign": "Eikenhouten uithangbord",
  "block.minecraft.oak_wall_sign": "Èèkehoutere burd an waand",
  "block.minecraft.oak_wood": "Èèkehout",
  "block.minecraft.observer": "Observeerder",
  "block.minecraft.obsidian": "Obsidiaan",
  "block.minecraft.ochre_froglight": "Okergeel kikkerlicht",
  "block.minecraft.ominous_banner": "Onheilspellende banier",
  "block.minecraft.open_eyeblossom": "Geopende gluurbloesem",
  "block.minecraft.orange_banner": "Oranje banier",
  "block.minecraft.orange_bed": "Oranje bed",
  "block.minecraft.orange_candle": "Oranje kèèrs",
  "block.minecraft.orange_candle_cake": "Vloai meej oranje kèèrs",
  "block.minecraft.orange_carpet": "Oranje tapijt",
  "block.minecraft.orange_concrete": "Oranje beton",
  "block.minecraft.orange_concrete_powder": "Oranje cement",
  "block.minecraft.orange_glazed_terracotta": "Oranjegeglaozuurde terracotta",
  "block.minecraft.orange_shulker_box": "Oranje shulkerdoâs",
  "block.minecraft.orange_stained_glass": "Oranjegekleurd glaos",
  "block.minecraft.orange_stained_glass_pane": "Oranjegekleurd glaoze rute",
  "block.minecraft.orange_terracotta": "Oranje terracotta",
  "block.minecraft.orange_tulip": "Oranje tullep",
  "block.minecraft.orange_wool": "Oranje wól",
  "block.minecraft.oxeye_daisy": "Margriet",
  "block.minecraft.oxidized_chiseled_copper": "Geoxideerd bewerkt koperblok",
  "block.minecraft.oxidized_copper": "Geoxideerd koperblok",
  "block.minecraft.oxidized_copper_bars": "Geoxideerde koperen tralies",
  "block.minecraft.oxidized_copper_bulb": "Geoxideerde koperen lamp",
  "block.minecraft.oxidized_copper_chain": "Geoxideerde koperen ketting",
  "block.minecraft.oxidized_copper_chest": "Geoxideerde koperen kist",
  "block.minecraft.oxidized_copper_door": "Geoxideerde koperen deur",
  "block.minecraft.oxidized_copper_golem_statue": "Geoxideerd kopergolemstandbeeld",
  "block.minecraft.oxidized_copper_grate": "Geoxideerd koperen rooster",
  "block.minecraft.oxidized_copper_lantern": "Geoxideerde koperen lantaarn",
  "block.minecraft.oxidized_copper_trapdoor": "Geoxideerd koperen valluik",
  "block.minecraft.oxidized_cut_copper": "Geoxideerd gesneje koperblok",
  "block.minecraft.oxidized_cut_copper_slab": "Geoxideerde gesneje kopere plôat",
  "block.minecraft.oxidized_cut_copper_stairs": "Geoxideerde gesneje kopere trep",
  "block.minecraft.oxidized_lightning_rod": "Geoxideerde bliksemafleider",
  "block.minecraft.packed_ice": "Pakèès",
  "block.minecraft.packed_mud": "Pakmodder",
  "block.minecraft.pale_hanging_moss": "Bleek hangend mos",
  "block.minecraft.pale_moss_block": "Bleek mosblok",
  "block.minecraft.pale_moss_carpet": "Bleek mostapijt",
  "block.minecraft.pale_oak_button": "Bleke eikenhouten knop",
  "block.minecraft.pale_oak_door": "Bleke eikenhouten deur",
  "block.minecraft.pale_oak_fence": "Bleek eikenhouten hek",
  "block.minecraft.pale_oak_fence_gate": "Bleke eikenhouten poort",
  "block.minecraft.pale_oak_hanging_sign": "Bleek eikenhouten hangbord",
  "block.minecraft.pale_oak_leaves": "Bleke eikenbladeren",
  "block.minecraft.pale_oak_log": "Bleke eikenstam",
  "block.minecraft.pale_oak_planks": "Bleke eikenhouten planken",
  "block.minecraft.pale_oak_pressure_plate": "Bleke eikenhouten drukplaat",
  "block.minecraft.pale_oak_sapling": "Bleke eikenzaailing",
  "block.minecraft.pale_oak_shelf": "Bleek eikenhouten schap",
  "block.minecraft.pale_oak_sign": "Bleek eikenhouten bord",
  "block.minecraft.pale_oak_slab": "Bleke eikenhouten plaat",
  "block.minecraft.pale_oak_stairs": "Bleke eikenhouten trap",
  "block.minecraft.pale_oak_trapdoor": "Bleke eikenhouten valluik",
  "block.minecraft.pale_oak_wall_hanging_sign": "Bleek eikenhouten uithangbord",
  "block.minecraft.pale_oak_wall_sign": "Bleek eikenhouten bord aan muur",
  "block.minecraft.pale_oak_wood": "Bleek eikenhout",
  "block.minecraft.pearlescent_froglight": "Paars kikkerlicht",
  "block.minecraft.peony": "Pioenroes",
  "block.minecraft.petrified_oak_slab": "Verstiende èèkehoutere plôat",
  "block.minecraft.piglin_head": "Piglinhoofd",
  "block.minecraft.piglin_wall_head": "Piglinhoofd aan muur",
  "block.minecraft.pink_banner": "Roze banier",
  "block.minecraft.pink_bed": "Raaze bed",
  "block.minecraft.pink_candle": "Raaze kèèrs",
  "block.minecraft.pink_candle_cake": "Vloai meej raaze kèèrs",
  "block.minecraft.pink_carpet": "Raaze tapijt",
  "block.minecraft.pink_concrete": "Raaze beton",
  "block.minecraft.pink_concrete_powder": "Raaze cement",
  "block.minecraft.pink_glazed_terracotta": "Raazegeglaozuurde terracotta",
  "block.minecraft.pink_petals": "Roze bloemblaadjes",
  "block.minecraft.pink_shulker_box": "Raaze shulkerdoâs",
  "block.minecraft.pink_stained_glass": "Raasgekleurd glaos",
  "block.minecraft.pink_stained_glass_pane": "Raasgekleurde glaoze rute",
  "block.minecraft.pink_terracotta": "Raaze terracotta",
  "block.minecraft.pink_tulip": "Raaze tullep",
  "block.minecraft.pink_wool": "Raaze wól",
  "block.minecraft.piston": "Zúúger",
  "block.minecraft.piston_head": "Zúúgerkop",
  "block.minecraft.pitcher_crop": "Bekerplantgewas",
  "block.minecraft.pitcher_plant": "Bekerplant",
  "block.minecraft.player_head": "Speulerhoofd",
  "block.minecraft.player_head.named": "Hoofd van %s",
  "block.minecraft.player_wall_head": "Speulerhoofd an waand",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Puntege drèùpstien",
  "block.minecraft.polished_andesite": "Gepolèèst andesiet",
  "block.minecraft.polished_andesite_slab": "Gepolèèste andesietplôat",
  "block.minecraft.polished_andesite_stairs": "Gepolèèste andesiettrep",
  "block.minecraft.polished_basalt": "Gepolèst basalt",
  "block.minecraft.polished_blackstone": "Gepolèèst zwertstien",
  "block.minecraft.polished_blackstone_brick_slab": "Gepolèèste zwertstienen blockstienen plôat",
  "block.minecraft.polished_blackstone_brick_stairs": "Gepolèèste zwertstienen blokstienen trep",
  "block.minecraft.polished_blackstone_brick_wall": "Gepolèèste zwertstienen blokstienen waand",
  "block.minecraft.polished_blackstone_bricks": "Gepolèèste zwertstienen blokstienen",
  "block.minecraft.polished_blackstone_button": "Gepolèèste zwertstienen knupke",
  "block.minecraft.polished_blackstone_pressure_plate": "Gepolèèste zwertstienen drôkplôat",
  "block.minecraft.polished_blackstone_slab": "Gepolèèste zwertstienen plôat",
  "block.minecraft.polished_blackstone_stairs": "Gepolèèste zwertstienen trep",
  "block.minecraft.polished_blackstone_wall": "Gepolèèste zwertstienen waand",
  "block.minecraft.polished_deepslate": "Gepolèèst wrevelstien",
  "block.minecraft.polished_deepslate_slab": "Gepolèèste wrevelstienen plôat",
  "block.minecraft.polished_deepslate_stairs": "Gepolèèste wrevelstienen trep",
  "block.minecraft.polished_deepslate_wall": "Gepolèèste wrevelstienen waand",
  "block.minecraft.polished_diorite": "Gepolèèst dioriet",
  "block.minecraft.polished_diorite_slab": "Gepolèèste diorietplôat",
  "block.minecraft.polished_diorite_stairs": "Gepolèèste dioriettrep",
  "block.minecraft.polished_granite": "Gepolèèst graniet",
  "block.minecraft.polished_granite_slab": "Gepolèèste granietplôat",
  "block.minecraft.polished_granite_stairs": "Gepolèèste graniettrep",
  "block.minecraft.polished_tuff": "Gepolijst tufsteen",
  "block.minecraft.polished_tuff_slab": "Gepolijste tufstenen plaat",
  "block.minecraft.polished_tuff_stairs": "Gepolijste tufstenen trap",
  "block.minecraft.polished_tuff_wall": "Gepolijste tufstenen muur",
  "block.minecraft.poppy": "Klaproes",
  "block.minecraft.potatoes": "Aerpels",
  "block.minecraft.potted_acacia_sapling": "Opgepotte acaciakiemplent",
  "block.minecraft.potted_allium": "Opgepot look",
  "block.minecraft.potted_azalea_bush": "Opgepotte azalea",
  "block.minecraft.potted_azure_bluet": "Opgepot porseleinsterretje",
  "block.minecraft.potted_bamboo": "Opgepotte bamboe",
  "block.minecraft.potted_birch_sapling": "Opgepotte birkekiemplent",
  "block.minecraft.potted_blue_orchid": "Opgepotte blaawe orchidee",
  "block.minecraft.potted_brown_mushroom": "Opgepotte brèùne paddestuul",
  "block.minecraft.potted_cactus": "Opgepotte cactus",
  "block.minecraft.potted_cherry_sapling": "Opgepotte kersenzaailing",
  "block.minecraft.potted_closed_eyeblossom": "Opgepotte gesloten gluurbloesem",
  "block.minecraft.potted_cornflower": "Opgepotte kollebluum",
  "block.minecraft.potted_crimson_fungus": "Opgepotte helrôoje zwam",
  "block.minecraft.potted_crimson_roots": "Opgepotte helrôoje peej'n",
  "block.minecraft.potted_dandelion": "Opgepotte pèèrdublom",
  "block.minecraft.potted_dark_oak_sapling": "Opgepotte Doenkerèèkekiemplent",
  "block.minecraft.potted_dead_bush": "Opgepotte dooie struuk",
  "block.minecraft.potted_fern": "Opgepotte varen",
  "block.minecraft.potted_flowering_azalea_bush": "Opgepotte bloeiende azalea",
  "block.minecraft.potted_golden_dandelion": "Opgepotte gouden paardenbloem",
  "block.minecraft.potted_jungle_sapling": "Opgepotte oerwoudkiemplent",
  "block.minecraft.potted_lily_of_the_valley": "Opgepot lelietje-van-dalen",
  "block.minecraft.potted_mangrove_propagule": "Opgepotte mangrovebroedknop",
  "block.minecraft.potted_oak_sapling": "Opgepotte èèkekiemplent",
  "block.minecraft.potted_open_eyeblossom": "Opgepotte geopende gluurbloesem",
  "block.minecraft.potted_orange_tulip": "Opgepotte oranje tullep",
  "block.minecraft.potted_oxeye_daisy": "Opgepotte margriet",
  "block.minecraft.potted_pale_oak_sapling": "Opgepotte bleke eikenzaailing",
  "block.minecraft.potted_pink_tulip": "Opgepotte raaze tullep",
  "block.minecraft.potted_poppy": "Opgepotte klaproes",
  "block.minecraft.potted_red_mushroom": "Opgepotte rooie paddestuul",
  "block.minecraft.potted_red_tulip": "Opgepotte rooie tullep",
  "block.minecraft.potted_spruce_sapling": "Opgepotte sparrenkiemplent",
  "block.minecraft.potted_torchflower": "Opgepotte fakkelbloem",
  "block.minecraft.potted_warped_fungus": "Opgepotte spoèkaetige zwam",
  "block.minecraft.potted_warped_roots": "Opgepotte spoèkaetige peej'n",
  "block.minecraft.potted_white_tulip": "Opgepotte wiete tullep",
  "block.minecraft.potted_wither_rose": "Opgepotte Witherroes",
  "block.minecraft.powder_snow": "Poejersneuw",
  "block.minecraft.powder_snow_cauldron": "Kittel meej poejersneuw",
  "block.minecraft.powered_rail": "Andrèèfrels",
  "block.minecraft.prismarine": "Prismarien",
  "block.minecraft.prismarine_brick_slab": "Prismarienblokstiene plôat",
  "block.minecraft.prismarine_brick_stairs": "Prismarienblokstienen trep",
  "block.minecraft.prismarine_bricks": "Prismarienblokstienen",
  "block.minecraft.prismarine_slab": "Prismarienplôat",
  "block.minecraft.prismarine_stairs": "Prismarientrep",
  "block.minecraft.prismarine_wall": "Prismarienwaand",
  "block.minecraft.pumpkin": "Pompoen",
  "block.minecraft.pumpkin_stem": "Pompoenstam",
  "block.minecraft.purple_banner": "Péérse banier",
  "block.minecraft.purple_bed": "Péérs bed",
  "block.minecraft.purple_candle": "Pèèrse kèèrs",
  "block.minecraft.purple_candle_cake": "Vloai meej pèèrse kèèrs",
  "block.minecraft.purple_carpet": "Péérs tapijt",
  "block.minecraft.purple_concrete": "Péérs beton",
  "block.minecraft.purple_concrete_powder": "Péérs cement",
  "block.minecraft.purple_glazed_terracotta": "Péérsgeglaozuurde terracotta",
  "block.minecraft.purple_shulker_box": "Péérse shulkerdoâs",
  "block.minecraft.purple_stained_glass": "Péérsgekleurd glaos",
  "block.minecraft.purple_stained_glass_pane": "Péérsgekleurde glaoze rute",
  "block.minecraft.purple_terracotta": "Péérs terracotta",
  "block.minecraft.purple_wool": "Péérse wól",
  "block.minecraft.purpur_block": "Purpurblok",
  "block.minecraft.purpur_pillar": "Purpurpeleer",
  "block.minecraft.purpur_slab": "Purpurplôat",
  "block.minecraft.purpur_stairs": "Purpurtrep",
  "block.minecraft.quartz_block": "Kwertsblok",
  "block.minecraft.quartz_bricks": "Kwertsblokstienen",
  "block.minecraft.quartz_pillar": "Kwertspeleer",
  "block.minecraft.quartz_slab": "Kwertsplôat",
  "block.minecraft.quartz_stairs": "Kwertstrep",
  "block.minecraft.rail": "Rels",
  "block.minecraft.raw_copper_block": "Ruw koperblok",
  "block.minecraft.raw_gold_block": "Ruw gawtblok",
  "block.minecraft.raw_iron_block": "Ruw èèzerblok",
  "block.minecraft.red_banner": "Rooie banier",
  "block.minecraft.red_bed": "Rooi bed",
  "block.minecraft.red_candle": "Rooie kèèrs",
  "block.minecraft.red_candle_cake": "Vloai meej rooie kèèrs",
  "block.minecraft.red_carpet": "Rooi tapijt",
  "block.minecraft.red_concrete": "Rooi beton",
  "block.minecraft.red_concrete_powder": "Rooi cement",
  "block.minecraft.red_glazed_terracotta": "Rooigeglaozuurde terracotta",
  "block.minecraft.red_mushroom": "Rooie paddestuul",
  "block.minecraft.red_mushroom_block": "Rooi paddestuuleblok",
  "block.minecraft.red_nether_brick_slab": "Rooie Netherbakstienen plôat",
  "block.minecraft.red_nether_brick_stairs": "Rooie Netherbakstienen trep",
  "block.minecraft.red_nether_brick_wall": "Rooie Netherbakstienen waand",
  "block.minecraft.red_nether_bricks": "Rooie Netherbakstienen",
  "block.minecraft.red_sand": "Rooi zaand",
  "block.minecraft.red_sandstone": "Rooi zaandstien",
  "block.minecraft.red_sandstone_slab": "Rooie zaandstienen plôat",
  "block.minecraft.red_sandstone_stairs": "Rooie zaandstienen trep",
  "block.minecraft.red_sandstone_wall": "Rooie zaandstienen waand",
  "block.minecraft.red_shulker_box": "Rooie shulkerdoâs",
  "block.minecraft.red_stained_glass": "Rooigekleurd glaos",
  "block.minecraft.red_stained_glass_pane": "Rooigekleurde glaoze rute",
  "block.minecraft.red_terracotta": "Rooi terracotta",
  "block.minecraft.red_tulip": "Rooie tullep",
  "block.minecraft.red_wool": "Rooie wól",
  "block.minecraft.redstone_block": "Redstoneblok",
  "block.minecraft.redstone_lamp": "Redstonelempke",
  "block.minecraft.redstone_ore": "Redstone-erts",
  "block.minecraft.redstone_torch": "Redstonefakkel",
  "block.minecraft.redstone_wall_torch": "Redstonefakkel an waand",
  "block.minecraft.redstone_wire": "Redstonedraoj",
  "block.minecraft.reinforced_deepslate": "Gewapend wrevelsteen",
  "block.minecraft.repeater": "Redstoneversterker",
  "block.minecraft.repeating_command_block": "Herhalend opdrachtblok",
  "block.minecraft.resin_block": "Harsblok",
  "block.minecraft.resin_brick_slab": "Harsbakstenen plaat",
  "block.minecraft.resin_brick_stairs": "Harsbakstenen trap",
  "block.minecraft.resin_brick_wall": "Harsbakstenen muur",
  "block.minecraft.resin_bricks": "Harsbakstenen",
  "block.minecraft.resin_clump": "Harsdruppels",
  "block.minecraft.respawn_anchor": "Respawnaankér",
  "block.minecraft.rooted_dirt": "Gewortelde èèrde",
  "block.minecraft.rose_bush": "Roêzestruuk",
  "block.minecraft.sand": "Zaand",
  "block.minecraft.sandstone": "Zaandstien",
  "block.minecraft.sandstone_slab": "Zaandstienen plôat",
  "block.minecraft.sandstone_stairs": "Zaandstienen trep",
  "block.minecraft.sandstone_wall": "Zaandstienen waand",
  "block.minecraft.scaffolding": "Staiger",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkkatalysator",
  "block.minecraft.sculk_sensor": "Sculksensor",
  "block.minecraft.sculk_shrieker": "Sculkkrijser",
  "block.minecraft.sculk_vein": "Sculkader",
  "block.minecraft.sea_lantern": "Ziejelantèère",
  "block.minecraft.sea_pickle": "Ziejekraal",
  "block.minecraft.seagrass": "Ziejegraas",
  "block.minecraft.set_spawn": "Respawnpunt ingesteld",
  "block.minecraft.short_dry_grass": "Kort droog gras",
  "block.minecraft.short_grass": "Kort gras",
  "block.minecraft.shroomlight": "Paddestuuleliecht",
  "block.minecraft.shulker_box": "Shulkerdoâs",
  "block.minecraft.skeleton_skull": "Skelettenschedel",
  "block.minecraft.skeleton_wall_skull": "Skelettenschedel aan muur",
  "block.minecraft.slime_block": "Sleumblok",
  "block.minecraft.small_amethyst_bud": "Klene amethistknup",
  "block.minecraft.small_dripleaf": "Klèèn drèùpblad",
  "block.minecraft.smithing_table": "Smeedstoafel",
  "block.minecraft.smoker": "Raoker",
  "block.minecraft.smooth_basalt": "Glàje basalt",
  "block.minecraft.smooth_quartz": "Glàje kwertsblok",
  "block.minecraft.smooth_quartz_slab": "Glàje kwertsplôat",
  "block.minecraft.smooth_quartz_stairs": "Glàje kwertstrep",
  "block.minecraft.smooth_red_sandstone": "Glàje rooi zaandstien",
  "block.minecraft.smooth_red_sandstone_slab": "Glàje rooie zaandstienen plôat",
  "block.minecraft.smooth_red_sandstone_stairs": "Glàje rooie zaandstienen trep",
  "block.minecraft.smooth_sandstone": "Glàje zaandstien",
  "block.minecraft.smooth_sandstone_slab": "Glàje zaandstienen plôat",
  "block.minecraft.smooth_sandstone_stairs": "Glàje zaandstienen trep",
  "block.minecraft.smooth_stone": "Glàje stien",
  "block.minecraft.smooth_stone_slab": "Glàje stienen plôat",
  "block.minecraft.sniffer_egg": "Snuffelaarsei",
  "block.minecraft.snow": "Sneuw",
  "block.minecraft.snow_block": "Sneuwblok",
  "block.minecraft.soul_campfire": "Zielekampvuurke",
  "block.minecraft.soul_fire": "Zielenvuurke",
  "block.minecraft.soul_lantern": "Zielenlantèère",
  "block.minecraft.soul_sand": "Zielenzaand",
  "block.minecraft.soul_soil": "Zielenèèrde",
  "block.minecraft.soul_torch": "Zielenfakkel",
  "block.minecraft.soul_wall_torch": "Zielenfakkel oan d'n waand",
  "block.minecraft.spawn.not_valid": "Oe hed gin bed of opgeloaje respawnanker of ze ware geblokkeerd",
  "block.minecraft.spawner": "Monsterkooi",
  "block.minecraft.spawner.desc1": "Interactie met spawnei:",
  "block.minecraft.spawner.desc2": "Bepaalt te spawnen wezentype",
  "block.minecraft.sponge": "Spons",
  "block.minecraft.spore_blossom": "Sporebloesem",
  "block.minecraft.spruce_button": "Sparrenhoutere knupke",
  "block.minecraft.spruce_door": "Sparrenhoutere deur",
  "block.minecraft.spruce_fence": "Sparrenhoutere hekke",
  "block.minecraft.spruce_fence_gate": "Sparrenhoutere poewert",
  "block.minecraft.spruce_hanging_sign": "Sparrenhouten hangbord",
  "block.minecraft.spruce_leaves": "Sparrennaolde",
  "block.minecraft.spruce_log": "Sparrenstam",
  "block.minecraft.spruce_planks": "Sparrenhoutere plaank",
  "block.minecraft.spruce_pressure_plate": "Sparrenhoutere drôkplôat",
  "block.minecraft.spruce_sapling": "Sparrenkiemplent",
  "block.minecraft.spruce_shelf": "Sparrenhouten schap",
  "block.minecraft.spruce_sign": "Sparrenhoutere burd",
  "block.minecraft.spruce_slab": "Sparrenhoutere plôat",
  "block.minecraft.spruce_stairs": "Sparrenhoutere trep",
  "block.minecraft.spruce_trapdoor": "Sparrenhoutere vaalluuk",
  "block.minecraft.spruce_wall_hanging_sign": "Sparrenhouten uithangbord",
  "block.minecraft.spruce_wall_sign": "Sparrenhoutere burd an waand",
  "block.minecraft.spruce_wood": "Sparrenhout",
  "block.minecraft.sticky_piston": "Kleefzúúger",
  "block.minecraft.stone": "Stien",
  "block.minecraft.stone_brick_slab": "Blokstiene plôat",
  "block.minecraft.stone_brick_stairs": "Blokstienen trep",
  "block.minecraft.stone_brick_wall": "Blokstienen waand",
  "block.minecraft.stone_bricks": "Blokstienen",
  "block.minecraft.stone_button": "Stienen knupke",
  "block.minecraft.stone_pressure_plate": "Stienen drôkplôat",
  "block.minecraft.stone_slab": "Stiene plôat",
  "block.minecraft.stone_stairs": "Stienen trep",
  "block.minecraft.stonecutter": "Stiensniejer",
  "block.minecraft.stripped_acacia_log": "Gestripte acaciastam",
  "block.minecraft.stripped_acacia_wood": "Gestript acaciahout",
  "block.minecraft.stripped_bamboo_block": "Gestript bamboeblok",
  "block.minecraft.stripped_birch_log": "Gestripte birkestam",
  "block.minecraft.stripped_birch_wood": "Gestript birkehout",
  "block.minecraft.stripped_cherry_log": "Gestripte kersenboomstam",
  "block.minecraft.stripped_cherry_wood": "Gestript kersenhout",
  "block.minecraft.stripped_crimson_hyphae": "Gestripte helrôoje schimmeldraoj",
  "block.minecraft.stripped_crimson_stem": "Gestripte helrôoje stam",
  "block.minecraft.stripped_dark_oak_log": "Gestripte doenkerèèkestam",
  "block.minecraft.stripped_dark_oak_wood": "Gestript doenkerèèkehout",
  "block.minecraft.stripped_jungle_log": "Gestripte oerwoudstam",
  "block.minecraft.stripped_jungle_wood": "Gestript oerwoudhout",
  "block.minecraft.stripped_mangrove_log": "Gestripte mangrovestam",
  "block.minecraft.stripped_mangrove_wood": "Gestript mangrovehout",
  "block.minecraft.stripped_oak_log": "Gestripte eikenstam",
  "block.minecraft.stripped_oak_wood": "Gestript èèkehout",
  "block.minecraft.stripped_pale_oak_log": "Gestripte bleke eikenstam",
  "block.minecraft.stripped_pale_oak_wood": "Gestript bleek eikenhout",
  "block.minecraft.stripped_spruce_log": "Gestripte sparrenstam",
  "block.minecraft.stripped_spruce_wood": "Gestript sparrenhout",
  "block.minecraft.stripped_warped_hyphae": "Gestripte spoèkachtige schummeldraoj",
  "block.minecraft.stripped_warped_stem": "Gestripte spoèkaetige stam",
  "block.minecraft.structure_block": "Konstruksieblok",
  "block.minecraft.structure_void": "Konstruksieleegte",
  "block.minecraft.sugar_cane": "Sokkerriet",
  "block.minecraft.sunflower": "Zonnebluum",
  "block.minecraft.suspicious_gravel": "Verdacht grind",
  "block.minecraft.suspicious_sand": "Verdacht zand",
  "block.minecraft.sweet_berry_bush": "Zuutbizemstruuk",
  "block.minecraft.tall_dry_grass": "Hoog droog gras",
  "block.minecraft.tall_grass": "Hoèg graas",
  "block.minecraft.tall_seagrass": "Hoèg ziejegraas",
  "block.minecraft.target": "Doelwit",
  "block.minecraft.terracotta": "Terracotta",
  "block.minecraft.test_block": "Testblok",
  "block.minecraft.test_instance_block": "Testinstantieblok",
  "block.minecraft.tinted_glass": "Getint gloas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT-explosies zijn uitgeschakeld",
  "block.minecraft.torch": "Fakkel",
  "block.minecraft.torchflower": "Fakkelbloem",
  "block.minecraft.torchflower_crop": "Fakkelbloemgewas",
  "block.minecraft.trapped_chest": "Kiest meej valstrik",
  "block.minecraft.trial_spawner": "Beproevingskooi",
  "block.minecraft.tripwire": "Strunkeldraoj",
  "block.minecraft.tripwire_hook": "Strunkeldraojhaok",
  "block.minecraft.tube_coral": "Buiskoraal",
  "block.minecraft.tube_coral_block": "Buiskoraalblok",
  "block.minecraft.tube_coral_fan": "Buiskoraalwaojer",
  "block.minecraft.tube_coral_wall_fan": "Buiskoraalwaojer an waand",
  "block.minecraft.tuff": "Tufstien",
  "block.minecraft.tuff_brick_slab": "Tufstenen blokstenen plaat",
  "block.minecraft.tuff_brick_stairs": "Tufstenen blokstenen trap",
  "block.minecraft.tuff_brick_wall": "Tufstenen blokstenen muur",
  "block.minecraft.tuff_bricks": "Tufstenen blokstenen",
  "block.minecraft.tuff_slab": "Tufstenen plaat",
  "block.minecraft.tuff_stairs": "Tufstenen trap",
  "block.minecraft.tuff_wall": "Tufstenen muur",
  "block.minecraft.turtle_egg": "Schildpadaaike",
  "block.minecraft.twisting_vines": "Verwikkelde klimop",
  "block.minecraft.twisting_vines_plant": "Verwikkelde klimplent",
  "block.minecraft.vault": "Kluis",
  "block.minecraft.verdant_froglight": "Groen kikkerlicht",
  "block.minecraft.vine": "Liaone",
  "block.minecraft.void_air": "Lochtledeghèèd",
  "block.minecraft.wall_torch": "Fakkel an waand",
  "block.minecraft.warped_button": "Spoèkaetige houtere knupke",
  "block.minecraft.warped_door": "Spoèkaetige houtere deure",
  "block.minecraft.warped_fence": "Spoèkaetig houtere hekke",
  "block.minecraft.warped_fence_gate": "Spoèkaetige houtere poewert",
  "block.minecraft.warped_fungus": "Spoèkaetige zwam",
  "block.minecraft.warped_hanging_sign": "Spookachtig houten hangbord",
  "block.minecraft.warped_hyphae": "Spoèkaetig schummeldraoj",
  "block.minecraft.warped_nylium": "Spoèkaetig nylium",
  "block.minecraft.warped_planks": "Spoèkaetige houtere plaank",
  "block.minecraft.warped_pressure_plate": "Spoèkaetige houtere drôkplôat",
  "block.minecraft.warped_roots": "Spoèkaetige peej'n",
  "block.minecraft.warped_shelf": "Spookachtig houten schap",
  "block.minecraft.warped_sign": "Spoèkaetig houtere burd",
  "block.minecraft.warped_slab": "Spoèkaetige houtere plôat",
  "block.minecraft.warped_stairs": "Spoèkaetige houtere trep",
  "block.minecraft.warped_stem": "Spoèkaetige stam",
  "block.minecraft.warped_trapdoor": "Spoèkaetig houtere vaalluuk",
  "block.minecraft.warped_wall_hanging_sign": "Spookachtig houten uithangbord",
  "block.minecraft.warped_wall_sign": "Spoèkaetig houtere burd oan waand",
  "block.minecraft.warped_wart_block": "Spoèkaetig krèùdblok",
  "block.minecraft.water": "Woatur",
  "block.minecraft.water_cauldron": "Woaturkittel",
  "block.minecraft.waxed_chiseled_copper": "Ingewassen bewerkt koperblok",
  "block.minecraft.waxed_copper_bars": "Ingewassen koperen tralies",
  "block.minecraft.waxed_copper_block": "Ingewasse koperblok",
  "block.minecraft.waxed_copper_bulb": "Ingewassen koperen lamp",
  "block.minecraft.waxed_copper_chain": "Ingewassen koperen ketting",
  "block.minecraft.waxed_copper_chest": "Ingewassen koperen kist",
  "block.minecraft.waxed_copper_door": "Ingewassen koperen deur",
  "block.minecraft.waxed_copper_golem_statue": "Ingewassen kopergolemstandbeeld",
  "block.minecraft.waxed_copper_grate": "Ingewassen koperen rooster",
  "block.minecraft.waxed_copper_lantern": "Ingewassen koperen lantaarn",
  "block.minecraft.waxed_copper_trapdoor": "Ingewassen koperen valluik",
  "block.minecraft.waxed_cut_copper": "Ingewasse gesneje koperblok",
  "block.minecraft.waxed_cut_copper_slab": "Ingewasse gesneje kopere plôat",
  "block.minecraft.waxed_cut_copper_stairs": "Ingewasse gesneje kopere trep",
  "block.minecraft.waxed_exposed_chiseled_copper": "Ingewassen blootgesteld bewerkt koperblok",
  "block.minecraft.waxed_exposed_copper": "Ingewasse blootgesteld koperblok",
  "block.minecraft.waxed_exposed_copper_bars": "Ingewassen blootgestelde koperen tralies",
  "block.minecraft.waxed_exposed_copper_bulb": "Ingewassen blootgestelde koperen lamp",
  "block.minecraft.waxed_exposed_copper_chain": "Ingewassen blootgestelde koperen ketting",
  "block.minecraft.waxed_exposed_copper_chest": "Ingewassen blootgestelde koperen kist",
  "block.minecraft.waxed_exposed_copper_door": "Ingewassen blootgestelde koperen deur",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Ingewassen blootgesteld kopergolemstandbeeld",
  "block.minecraft.waxed_exposed_copper_grate": "Ingewassen blootgesteld koperen rooster",
  "block.minecraft.waxed_exposed_copper_lantern": "Ingewassen blootgestelde koperen lantaarn",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Ingewassen blootgesteld koperen valluik",
  "block.minecraft.waxed_exposed_cut_copper": "Ingewasse blootgesteld gesneje koperblok",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Ingewasse blootgestelde gesneje kopere plôat",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Ingewasse blootgestelde gesnejen kopere trep",
  "block.minecraft.waxed_exposed_lightning_rod": "Ingewassen blootgestelde bliksemafleider",
  "block.minecraft.waxed_lightning_rod": "Ingewassen bliksemafleider",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Ingewassen geoxideerd bewerkt koperblok",
  "block.minecraft.waxed_oxidized_copper": "Ingewasse geoxideerd koperblok",
  "block.minecraft.waxed_oxidized_copper_bars": "Ingewassen geoxideerde koperen tralies",
  "block.minecraft.waxed_oxidized_copper_bulb": "Ingewassen geoxideerde koperen lamp",
  "block.minecraft.waxed_oxidized_copper_chain": "Ingewassen geoxideerde koperen ketting",
  "block.minecraft.waxed_oxidized_copper_chest": "Ingewassen geoxideerde koperen kist",
  "block.minecraft.waxed_oxidized_copper_door": "Ingewassen geoxideerde koperen deur",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Ingewassen geoxideerd kopergolemstandbeeld",
  "block.minecraft.waxed_oxidized_copper_grate": "Ingewassen geoxideerd koperen rooster",
  "block.minecraft.waxed_oxidized_copper_lantern": "Ingewassen geoxideerde koperen lantaarn",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Ingewassen geoxideerd koperen valluik",
  "block.minecraft.waxed_oxidized_cut_copper": "Ingewasse geoxideerd gesneje koperblok",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Ingewasse geoxideerde gesneje kopere plôat",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Ingewasse geoxideerde gesneje kopere trep",
  "block.minecraft.waxed_oxidized_lightning_rod": "Ingewassen geoxideerde bliksemafleider",
  "block.minecraft.waxed_weathered_chiseled_copper": "Ingewassen verweerd bewerkt koperblok",
  "block.minecraft.waxed_weathered_copper": "Ingewasse verweerd koperblok",
  "block.minecraft.waxed_weathered_copper_bars": "Ingewassen verweerde koperen tralies",
  "block.minecraft.waxed_weathered_copper_bulb": "Ingewassen verweerde koperen lamp",
  "block.minecraft.waxed_weathered_copper_chain": "Ingewassen verweerde koperen ketting",
  "block.minecraft.waxed_weathered_copper_chest": "Ingewassen verweerde koperen kist",
  "block.minecraft.waxed_weathered_copper_door": "Ingewassen verweerde koperen deur",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Ingewassen verweerd kopergolemstandbeeld",
  "block.minecraft.waxed_weathered_copper_grate": "Ingewassen verweerd koperen rooster",
  "block.minecraft.waxed_weathered_copper_lantern": "Ingewassen verweerde koperen lantaarn",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Ingewassen verweerd koperen valluik",
  "block.minecraft.waxed_weathered_cut_copper": "Ingewasse verweerd gesneje koperblok",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Ingewasse verweerde gesneje kopere plôat",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Ingewasse verweerde gesneje kopere trep",
  "block.minecraft.waxed_weathered_lightning_rod": "Ingewassen verweerde bliksemafleider",
  "block.minecraft.weathered_chiseled_copper": "Verweerd bewerkt koperblok",
  "block.minecraft.weathered_copper": "Verweerd koperblok",
  "block.minecraft.weathered_copper_bars": "Verweerde koperen tralies",
  "block.minecraft.weathered_copper_bulb": "Verweerde koperen lamp",
  "block.minecraft.weathered_copper_chain": "Verweerde koperen ketting",
  "block.minecraft.weathered_copper_chest": "Verweerde koperen kist",
  "block.minecraft.weathered_copper_door": "Verweerde koperen deur",
  "block.minecraft.weathered_copper_golem_statue": "Verweerd kopergolemstandbeeld",
  "block.minecraft.weathered_copper_grate": "Verweerd koperen rooster",
  "block.minecraft.weathered_copper_lantern": "Verweerde koperen lantaarn",
  "block.minecraft.weathered_copper_trapdoor": "Verweerd koperen valluik",
  "block.minecraft.weathered_cut_copper": "Verweerd gesneje koperblok",
  "block.minecraft.weathered_cut_copper_slab": "Verweerde gesneje kopere plôat",
  "block.minecraft.weathered_cut_copper_stairs": "Verweerde gesneje kopere trep",
  "block.minecraft.weathered_lightning_rod": "Verweerde bliksemafleider",
  "block.minecraft.weeping_vines": "Hangende klimop",
  "block.minecraft.weeping_vines_plant": "Hangende klimplent",
  "block.minecraft.wet_sponge": "Naote spons",
  "block.minecraft.wheat": "Terf",
  "block.minecraft.white_banner": "Witte banier",
  "block.minecraft.white_bed": "Wiet bed",
  "block.minecraft.white_candle": "Wiete kèèrs",
  "block.minecraft.white_candle_cake": "Vloai meej wiete kèèrs",
  "block.minecraft.white_carpet": "Wiet tapijt",
  "block.minecraft.white_concrete": "Wiet beton",
  "block.minecraft.white_concrete_powder": "Wiet cement",
  "block.minecraft.white_glazed_terracotta": "Wietgeglaozuurde terracotta",
  "block.minecraft.white_shulker_box": "Wiete shulkerdoâs",
  "block.minecraft.white_stained_glass": "Wietgekleurd glaos",
  "block.minecraft.white_stained_glass_pane": "Wietgekleurd glaos",
  "block.minecraft.white_terracotta": "Wiet terracotta",
  "block.minecraft.white_tulip": "Wiete tullep",
  "block.minecraft.white_wool": "Wiete wól",
  "block.minecraft.wildflowers": "Wilde bloemen",
  "block.minecraft.wither_rose": "Witherroes",
  "block.minecraft.wither_skeleton_skull": "Witherskelettenschedel",
  "block.minecraft.wither_skeleton_wall_skull": "Witherskelettenschedel an waand",
  "block.minecraft.yellow_banner": "Gele banier",
  "block.minecraft.yellow_bed": "Gèèl bed",
  "block.minecraft.yellow_candle": "Gele kèèrs",
  "block.minecraft.yellow_candle_cake": "Vloai meej gele kèèrs",
  "block.minecraft.yellow_carpet": "Gèèl tapijt",
  "block.minecraft.yellow_concrete": "Gèèl beton",
  "block.minecraft.yellow_concrete_powder": "Gèèl cement",
  "block.minecraft.yellow_glazed_terracotta": "Gèèlgeglaozuurde terracotta",
  "block.minecraft.yellow_shulker_box": "Gele shulkerdoâs",
  "block.minecraft.yellow_stained_glass": "Gèèlgekleurd glaos",
  "block.minecraft.yellow_stained_glass_pane": "Gèèlgekleurde glaoze rute",
  "block.minecraft.yellow_terracotta": "Gèèl terracotta",
  "block.minecraft.yellow_wool": "Gele wól",
  "block.minecraft.zombie_head": "Zombiehoofd",
  "block.minecraft.zombie_wall_head": "Zombiehoofd an waand",
  "item.minecraft.acacia_boat": "Acaciahoutere bwoat",
  "item.minecraft.acacia_chest_boat": "Acaciahouten boot met kist",
  "item.minecraft.allay_spawn_egg": "Helperspawnei",
  "item.minecraft.amethyst_shard": "Amethistscherf",
  "item.minecraft.angler_pottery_shard": "Aardewerkscherf 'visser'",
  "item.minecraft.angler_pottery_sherd": "Aardewerkscherf 'visser'",
  "item.minecraft.apple": "Appol",
  "item.minecraft.archer_pottery_shard": "Aardewerkscherf 'boogschutter'",
  "item.minecraft.archer_pottery_sherd": "Aardewerkscherf 'boogschutter'",
  "item.minecraft.armadillo_scute": "Gordeldierhoornplaat",
  "item.minecraft.armadillo_spawn_egg": "Gordeldierenspawnei",
  "item.minecraft.armor_stand": "Harnashaawer",
  "item.minecraft.arms_up_pottery_shard": "Aardewerkscherf 'geheven armen'",
  "item.minecraft.arms_up_pottery_sherd": "Aardewerkscherf 'geheven armen'",
  "item.minecraft.arrow": "Pèèl",
  "item.minecraft.axolotl_bucket": "Emmer axolotl",
  "item.minecraft.axolotl_spawn_egg": "Axolotlspawnei",
  "item.minecraft.baked_potato": "Gebakke erpel",
  "item.minecraft.bamboo_chest_raft": "Bamboevlot met kist",
  "item.minecraft.bamboo_raft": "Bamboevlot",
  "item.minecraft.bat_spawn_egg": "Vlirmèùzespawnei",
  "item.minecraft.bee_spawn_egg": "Biejespawnei",
  "item.minecraft.beef": "Raawe bufsteek",
  "item.minecraft.beetroot": "Béét",
  "item.minecraft.beetroot_seeds": "Béétezaoje",
  "item.minecraft.beetroot_soup": "Béétesuupke",
  "item.minecraft.birch_boat": "Birkehoutere boot",
  "item.minecraft.birch_chest_boat": "Berkenhouten boot met kist",
  "item.minecraft.black_bundle": "Zwarte bundel",
  "item.minecraft.black_dye": "Zwerte koleurstobber",
  "item.minecraft.black_harness": "Zwart tuig",
  "item.minecraft.blade_pottery_shard": "Aardewerkscherf 'zwaard'",
  "item.minecraft.blade_pottery_sherd": "Aardewerkscherf 'zwaard'",
  "item.minecraft.blaze_powder": "Blazepoejer",
  "item.minecraft.blaze_rod": "Blazestaf",
  "item.minecraft.blaze_spawn_egg": "Blazespawnei",
  "item.minecraft.blue_bundle": "Blauwe bundel",
  "item.minecraft.blue_dye": "Blaawe koleurstobber",
  "item.minecraft.blue_egg": "Blauw ei",
  "item.minecraft.blue_harness": "Blauw tuig",
  "item.minecraft.bogged_spawn_egg": "Zomperspawnei",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Harnasversiering 'bout'",
  "item.minecraft.bone": "Bot",
  "item.minecraft.bone_meal": "Beendermeel",
  "item.minecraft.book": "Buuk",
  "item.minecraft.bordure_indented_banner_pattern": "Ingesprongenzoombanierpatroon",
  "item.minecraft.bow": "Baog",
  "item.minecraft.bowl": "Kom",
  "item.minecraft.bread": "Brooike",
  "item.minecraft.breeze_rod": "Vlaagstaf",
  "item.minecraft.breeze_spawn_egg": "Vlagenspawnei",
  "item.minecraft.brewer_pottery_shard": "Aardewerkscherf 'brouwer'",
  "item.minecraft.brewer_pottery_sherd": "Aardewerkscherf 'brouwer'",
  "item.minecraft.brewing_stand": "Brouwstandaard",
  "item.minecraft.brick": "Bakstien",
  "item.minecraft.brown_bundle": "Bruine bundel",
  "item.minecraft.brown_dye": "Brèùne koleurstobber",
  "item.minecraft.brown_egg": "Bruin ei",
  "item.minecraft.brown_harness": "Bruin tuig",
  "item.minecraft.brush": "Borstel",
  "item.minecraft.bucket": "Eemer",
  "item.minecraft.bundle": "Bussel",
  "item.minecraft.bundle.empty": "Leeg",
  "item.minecraft.bundle.empty.description": "Kan een stapel van verschillende voorwerpen vasthouden",
  "item.minecraft.bundle.full": "Vol",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Aardewerkscherf 'branden'",
  "item.minecraft.burn_pottery_sherd": "Aardewerkscherf 'branden'",
  "item.minecraft.camel_husk_spawn_egg": "Dromedarismummiespawnei",
  "item.minecraft.camel_spawn_egg": "Dromedarisspawnei",
  "item.minecraft.carrot": "Pee",
  "item.minecraft.carrot_on_a_stick": "Pee an 'n stok",
  "item.minecraft.cat_spawn_egg": "Dakhaozespawnei",
  "item.minecraft.cauldron": "Ketel",
  "item.minecraft.cave_spider_spawn_egg": "Grottespinnespawnei",
  "item.minecraft.chainmail_boots": "Maliën lers",
  "item.minecraft.chainmail_chestplate": "Maliën borstploat",
  "item.minecraft.chainmail_helmet": "Maliënkapke",
  "item.minecraft.chainmail_leggings": "Maliën bienstukken",
  "item.minecraft.charcoal": "Houtskôol",
  "item.minecraft.cherry_boat": "Kersenhouten boot",
  "item.minecraft.cherry_chest_boat": "Kersenhouten boot met kist",
  "item.minecraft.chest_minecart": "Mijnkar meej kiest",
  "item.minecraft.chicken": "Raawe kiekke",
  "item.minecraft.chicken_spawn_egg": "Kiekkespawnei",
  "item.minecraft.chorus_fruit": "Chorusfroët",
  "item.minecraft.clay_ball": "Klaaibal",
  "item.minecraft.clock": "Klok",
  "item.minecraft.coal": "Stienkôol",
  "item.minecraft.coast_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Harnasversiering 'kust'",
  "item.minecraft.cocoa_beans": "Cacaobonne",
  "item.minecraft.cod": "Raawe kabeljauw",
  "item.minecraft.cod_bucket": "Eemer kabeljauw",
  "item.minecraft.cod_spawn_egg": "Kabeljauwspawnei",
  "item.minecraft.command_block_minecart": "Mijnkar meej opdrachtblok",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Bufsteek",
  "item.minecraft.cooked_chicken": "Gebraoje kiekke",
  "item.minecraft.cooked_cod": "Gebakken kabeljauw",
  "item.minecraft.cooked_mutton": "Gebraoje schaopenvlis",
  "item.minecraft.cooked_porkchop": "Gebraoje kuusvlis",
  "item.minecraft.cooked_rabbit": "Gebraoje knijnenvlis",
  "item.minecraft.cooked_salmon": "Gebakken zalm",
  "item.minecraft.cookie": "Kuukske",
  "item.minecraft.copper_axe": "Koperen bijl",
  "item.minecraft.copper_boots": "Koperen laarzen",
  "item.minecraft.copper_chestplate": "Koperen borstplaat",
  "item.minecraft.copper_golem_spawn_egg": "Kopergolemspawnei",
  "item.minecraft.copper_helmet": "Koperen helm",
  "item.minecraft.copper_hoe": "Koperen schoffel",
  "item.minecraft.copper_horse_armor": "Koperen paardenharnas",
  "item.minecraft.copper_ingot": "Koperstaof",
  "item.minecraft.copper_leggings": "Koperen beenstukken",
  "item.minecraft.copper_nautilus_armor": "Koperen nautilusharnas",
  "item.minecraft.copper_nugget": "Koperklompje",
  "item.minecraft.copper_pickaxe": "Koperen houweel",
  "item.minecraft.copper_shovel": "Koperen schep",
  "item.minecraft.copper_spear": "Koperen speer",
  "item.minecraft.copper_sword": "Koperen zwaard",
  "item.minecraft.cow_spawn_egg": "Koeienspawnei",
  "item.minecraft.creaking_spawn_egg": "Schorswakerspawnei",
  "item.minecraft.creeper_banner_pattern": "Banierpetroen",
  "item.minecraft.creeper_banner_pattern.desc": "Creeperwaope",
  "item.minecraft.creeper_banner_pattern.new": "Creeperwapenbanierpatroon",
  "item.minecraft.creeper_spawn_egg": "Creeperspawnei",
  "item.minecraft.crossbow": "Krèùsbaog",
  "item.minecraft.crossbow.projectile": "Projectiel:",
  "item.minecraft.crossbow.projectile.multiple": "Projectiel: %s × %s",
  "item.minecraft.crossbow.projectile.single": "Projectiel: %s",
  "item.minecraft.cyan_bundle": "Turquoise bundel",
  "item.minecraft.cyan_dye": "Turquoise koleurstobber",
  "item.minecraft.cyan_harness": "Turquoise tuig",
  "item.minecraft.danger_pottery_shard": "Aardewerkscherf 'gevaar'",
  "item.minecraft.danger_pottery_sherd": "Aardewerkscherf 'gevaar'",
  "item.minecraft.dark_oak_boat": "Doenkere èèkehoutere bwoat",
  "item.minecraft.dark_oak_chest_boat": "Donkere eikenhouten boot met kist",
  "item.minecraft.debug_stick": "Debugstok",
  "item.minecraft.debug_stick.empty": "%s hed gin èègeschappen",
  "item.minecraft.debug_stick.select": "'%s' geselekteerd (%s)",
  "item.minecraft.debug_stick.update": "'%s' nôàr %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamanten bèèl",
  "item.minecraft.diamond_boots": "Diamanten laarzen",
  "item.minecraft.diamond_chestplate": "Diamanten borstploat",
  "item.minecraft.diamond_helmet": "Diamanten butsmuts",
  "item.minecraft.diamond_hoe": "Diamanten schreepel",
  "item.minecraft.diamond_horse_armor": "Diamanten peerdeharnas",
  "item.minecraft.diamond_leggings": "Diamanten bienstukken",
  "item.minecraft.diamond_nautilus_armor": "Diamanten nautilusharnas",
  "item.minecraft.diamond_pickaxe": "Diamanten houweel",
  "item.minecraft.diamond_shovel": "Diamanten schup",
  "item.minecraft.diamond_spear": "Diamanten speer",
  "item.minecraft.diamond_sword": "Diamanten zwaord",
  "item.minecraft.disc_fragment_5": "Muziekplaatfragment",
  "item.minecraft.disc_fragment_5.desc": "Muziekplaat - 5",
  "item.minecraft.dolphin_spawn_egg": "Dolfijnenspawnei",
  "item.minecraft.donkey_spawn_egg": "Eezelspawnei",
  "item.minecraft.dragon_breath": "Draokenaosem",
  "item.minecraft.dried_kelp": "Gedrêûgde kelp",
  "item.minecraft.drowned_spawn_egg": "Drenkelingespawnei",
  "item.minecraft.dune_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Harnasversiering 'duin'",
  "item.minecraft.echo_shard": "Echoscherf",
  "item.minecraft.egg": "Ai",
  "item.minecraft.elder_guardian_spawn_egg": "Aawebewaokerspawnei",
  "item.minecraft.elytra": "Dekschild",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Beteuverd buuk",
  "item.minecraft.enchanted_golden_apple": "Betoverde gaawe appol",
  "item.minecraft.end_crystal": "Endkristal",
  "item.minecraft.ender_dragon_spawn_egg": "Enderdrakenspawnei",
  "item.minecraft.ender_eye": "Enderôôg",
  "item.minecraft.ender_pearl": "Enderparel",
  "item.minecraft.enderman_spawn_egg": "Endermanspawnei",
  "item.minecraft.endermite_spawn_egg": "Endermijtspawnei",
  "item.minecraft.evoker_spawn_egg": "Oproeperspawnei",
  "item.minecraft.experience_bottle": "Magiërsextract",
  "item.minecraft.explorer_pottery_shard": "Aardewerkscherf 'ontdekker'",
  "item.minecraft.explorer_pottery_sherd": "Aardewerkscherf 'ontdekker'",
  "item.minecraft.eye_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Harnasversiering 'oog'",
  "item.minecraft.feather": "Veer",
  "item.minecraft.fermented_spider_eye": "Gefermenteerd spinnenôôg",
  "item.minecraft.field_masoned_banner_pattern": "Metselwerkbanierpatroon",
  "item.minecraft.filled_map": "Koart",
  "item.minecraft.fire_charge": "Vuurbal",
  "item.minecraft.firework_rocket": "Vuurpèèl",
  "item.minecraft.firework_rocket.flight": "Vluchtduur:",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Vuurweirekstaar",
  "item.minecraft.firework_star.black": "Zwert",
  "item.minecraft.firework_star.blue": "Blaaw",
  "item.minecraft.firework_star.brown": "Brèùn",
  "item.minecraft.firework_star.custom_color": "Aangepast",
  "item.minecraft.firework_star.cyan": "Turquoise",
  "item.minecraft.firework_star.fade_to": "Euvergank nôàr",
  "item.minecraft.firework_star.flicker": "Twinkel",
  "item.minecraft.firework_star.gray": "Grèès",
  "item.minecraft.firework_star.green": "Grún",
  "item.minecraft.firework_star.light_blue": "Liechtblaaw",
  "item.minecraft.firework_star.light_gray": "Liechtgrèès",
  "item.minecraft.firework_star.lime": "Liechtgrún",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Oranje",
  "item.minecraft.firework_star.pink": "Raaze",
  "item.minecraft.firework_star.purple": "Péérs",
  "item.minecraft.firework_star.red": "Rooi",
  "item.minecraft.firework_star.shape": "Onbekende vurm",
  "item.minecraft.firework_star.shape.burst": "Explaosie",
  "item.minecraft.firework_star.shape.creeper": "Creepervurmèg",
  "item.minecraft.firework_star.shape.large_ball": "Groewte bal",
  "item.minecraft.firework_star.shape.small_ball": "Klene bal",
  "item.minecraft.firework_star.shape.star": "Staarvurmèg",
  "item.minecraft.firework_star.trail": "Spoor",
  "item.minecraft.firework_star.white": "Wiet",
  "item.minecraft.firework_star.yellow": "Gèèl",
  "item.minecraft.fishing_rod": "Vèsgèèrt",
  "item.minecraft.flint": "Vuurstien",
  "item.minecraft.flint_and_steel": "Allemeur",
  "item.minecraft.flow_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Harnasversiering 'windstroming'",
  "item.minecraft.flow_banner_pattern": "Banierpatroon",
  "item.minecraft.flow_banner_pattern.desc": "Windstroming",
  "item.minecraft.flow_banner_pattern.new": "Windstromingbanierpatroon",
  "item.minecraft.flow_pottery_sherd": "Aardewerkscherf 'windstroming'",
  "item.minecraft.flower_banner_pattern": "Banierpatroon",
  "item.minecraft.flower_banner_pattern.desc": "Blomwaope",
  "item.minecraft.flower_banner_pattern.new": "Bloemwapenbanierpatroon",
  "item.minecraft.flower_pot": "Bloempot",
  "item.minecraft.fox_spawn_egg": "Vossenspawnei",
  "item.minecraft.friend_pottery_shard": "Aardewerkscherf 'vriend'",
  "item.minecraft.friend_pottery_sherd": "Aardewerkscherf 'vriend'",
  "item.minecraft.frog_spawn_egg": "Kikkerspawnei",
  "item.minecraft.furnace_minecart": "Mijnkar meej oove",
  "item.minecraft.ghast_spawn_egg": "Ghastspawnei",
  "item.minecraft.ghast_tear": "Ghasttraon",
  "item.minecraft.glass_bottle": "Glaoze flesse",
  "item.minecraft.glistering_melon_slice": "Gliensterende meloenschèèf",
  "item.minecraft.globe_banner_pattern": "Banierpatroon",
  "item.minecraft.globe_banner_pattern.desc": "Globe",
  "item.minecraft.globe_banner_pattern.new": "Globebanierpatroon",
  "item.minecraft.glow_berries": "Glooibesse",
  "item.minecraft.glow_ink_sac": "Glooiende enkbuil",
  "item.minecraft.glow_item_frame": "Glooiende veurwerplèèst",
  "item.minecraft.glow_squid_spawn_egg": "Glooiende-enkviesespawnei",
  "item.minecraft.glowstone_dust": "Gleujstienstobber",
  "item.minecraft.goat_horn": "Geitenhoorn",
  "item.minecraft.goat_spawn_egg": "Gèètespawnei",
  "item.minecraft.gold_ingot": "Gawtstoaf",
  "item.minecraft.gold_nugget": "Gawtklumpke",
  "item.minecraft.golden_apple": "Gaawe appol",
  "item.minecraft.golden_axe": "Gaawe bèèl",
  "item.minecraft.golden_boots": "Gaawe lers",
  "item.minecraft.golden_carrot": "Gaawe pee",
  "item.minecraft.golden_chestplate": "Gaawe borstploat",
  "item.minecraft.golden_helmet": "Gaawe butsmuts",
  "item.minecraft.golden_hoe": "Gaawe schreepel",
  "item.minecraft.golden_horse_armor": "Gaawe peerdeharnas",
  "item.minecraft.golden_leggings": "Gaawe bienstukken",
  "item.minecraft.golden_nautilus_armor": "Gouden nautilusharnas",
  "item.minecraft.golden_pickaxe": "Gaawe houweel",
  "item.minecraft.golden_shovel": "Gaawe schup",
  "item.minecraft.golden_spear": "Gouden speer",
  "item.minecraft.golden_sword": "Gaawe zwaord",
  "item.minecraft.gray_bundle": "Grijze bundel",
  "item.minecraft.gray_dye": "Grèèze koleurstobber",
  "item.minecraft.gray_harness": "Grijs tuig",
  "item.minecraft.green_bundle": "Groene bundel",
  "item.minecraft.green_dye": "Grúne koleurstobber",
  "item.minecraft.green_harness": "Groen tuig",
  "item.minecraft.guardian_spawn_egg": "Bewaokerspawnei",
  "item.minecraft.gunpowder": "Buskrèùd",
  "item.minecraft.guster_banner_pattern": "Banierpatroon",
  "item.minecraft.guster_banner_pattern.desc": "Rukwind",
  "item.minecraft.guster_banner_pattern.new": "Rukwindbanierpatroon",
  "item.minecraft.guster_pottery_sherd": "Aardewerkscherf 'rukwind'",
  "item.minecraft.happy_ghast_spawn_egg": "Vrolijkeghastspawnei",
  "item.minecraft.harness": "Tuig",
  "item.minecraft.heart_of_the_sea": "Hèrt van d'n zieje",
  "item.minecraft.heart_pottery_shard": "Aardewerkscherf 'hart'",
  "item.minecraft.heart_pottery_sherd": "Aardewerkscherf 'hart'",
  "item.minecraft.heartbreak_pottery_shard": "Aardewerkscherf 'gebroken hart'",
  "item.minecraft.heartbreak_pottery_sherd": "Aardewerkscherf 'gebroken hart'",
  "item.minecraft.hoglin_spawn_egg": "Hoglinspawnei",
  "item.minecraft.honey_bottle": "Hoennekfles",
  "item.minecraft.honeycomb": "Hoennekgroat",
  "item.minecraft.hopper_minecart": "Mijnkar meej trefter",
  "item.minecraft.horse_spawn_egg": "Peerdespawnei",
  "item.minecraft.host_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.host_armor_trim_smithing_template.new": "Harnasversiering 'gastheer'",
  "item.minecraft.howl_pottery_shard": "Aardewerkscherf 'huilen'",
  "item.minecraft.howl_pottery_sherd": "Aardewerkscherf 'huilen'",
  "item.minecraft.husk_spawn_egg": "Mummiespawnei",
  "item.minecraft.ink_sac": "Enkbuil",
  "item.minecraft.iron_axe": "Èèzere bèèl",
  "item.minecraft.iron_boots": "Èèzere lers",
  "item.minecraft.iron_chestplate": "Èèzere borstploat",
  "item.minecraft.iron_golem_spawn_egg": "IJzergolemspawnei",
  "item.minecraft.iron_helmet": "Èèzere butsmuts",
  "item.minecraft.iron_hoe": "Èèzere schrepel",
  "item.minecraft.iron_horse_armor": "Èèzere peerdeharnas",
  "item.minecraft.iron_ingot": "Èèzerstaof",
  "item.minecraft.iron_leggings": "Èèzere bienstukken",
  "item.minecraft.iron_nautilus_armor": "IJzeren nautilusharnas",
  "item.minecraft.iron_nugget": "Èèzerklumke",
  "item.minecraft.iron_pickaxe": "Èèzere houweel",
  "item.minecraft.iron_shovel": "Èèzere schup",
  "item.minecraft.iron_spear": "IJzeren speer",
  "item.minecraft.iron_sword": "Èèzere zwaord",
  "item.minecraft.item_frame": "Veurwerplèèst",
  "item.minecraft.jungle_boat": "Oerwoudhoutere boot",
  "item.minecraft.jungle_chest_boat": "Oerwoudhouten boot met kist",
  "item.minecraft.knowledge_book": "Buuk der kennus",
  "item.minecraft.lapis_lazuli": "Lapis lazuli",
  "item.minecraft.lava_bucket": "Eemer lava",
  "item.minecraft.lead": "Leijzeel",
  "item.minecraft.leather": "Liere",
  "item.minecraft.leather_boots": "Liere lers",
  "item.minecraft.leather_chestplate": "Liere tuniek",
  "item.minecraft.leather_helmet": "Liere kap",
  "item.minecraft.leather_horse_armor": "Liere peerdeharnas",
  "item.minecraft.leather_leggings": "Liere boxbin",
  "item.minecraft.light_blue_bundle": "Lichtblauwe bundel",
  "item.minecraft.light_blue_dye": "Liechtblaawe koleurstobber",
  "item.minecraft.light_blue_harness": "Lichtblauw tuig",
  "item.minecraft.light_gray_bundle": "Lichtgrijze bundel",
  "item.minecraft.light_gray_dye": "Liechtgrèèze koleurstobber",
  "item.minecraft.light_gray_harness": "Lichtgrijs tuig",
  "item.minecraft.lime_bundle": "Lichtgroene bundel",
  "item.minecraft.lime_dye": "Liechtgrúne koleurstobber",
  "item.minecraft.lime_harness": "Lichtgroen tuig",
  "item.minecraft.lingering_potion": "Anhaawende draank",
  "item.minecraft.lingering_potion.effect.awkward": "Aonhaawende vreemde draank",
  "item.minecraft.lingering_potion.effect.empty": "Aonhaawende onmoakbare draank",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Aonhaawende draank der vuurbestendeghèèd",
  "item.minecraft.lingering_potion.effect.harming": "Aonhaawende draank der verwonding",
  "item.minecraft.lingering_potion.effect.healing": "Aonhaawende draank der genezing",
  "item.minecraft.lingering_potion.effect.infested": "Aanhoudende drank der infestatie",
  "item.minecraft.lingering_potion.effect.invisibility": "Aonhaawende draank der onzichtbaarhèèd",
  "item.minecraft.lingering_potion.effect.leaping": "Aonhaawende draank der sprongen",
  "item.minecraft.lingering_potion.effect.levitation": "Aonhaawende draank der zweving",
  "item.minecraft.lingering_potion.effect.luck": "Aonhaawende draank des geluks",
  "item.minecraft.lingering_potion.effect.mundane": "Aonhaawende triviale draank",
  "item.minecraft.lingering_potion.effect.night_vision": "Aonhaawende draank des nachtzichts",
  "item.minecraft.lingering_potion.effect.oozing": "Aanhoudende drank der slijmerigheid",
  "item.minecraft.lingering_potion.effect.poison": "Aonhaawende draank des gifs",
  "item.minecraft.lingering_potion.effect.regeneration": "Aonhaawende draank der regeneraosie",
  "item.minecraft.lingering_potion.effect.slow_falling": "Aonhaawende draank der valvertraoging",
  "item.minecraft.lingering_potion.effect.slowness": "Aonhaawende draank der traoghèèd",
  "item.minecraft.lingering_potion.effect.strength": "Aonhaawende draank der kracht",
  "item.minecraft.lingering_potion.effect.swiftness": "Aonhaawende draank der vlothèèd",
  "item.minecraft.lingering_potion.effect.thick": "Aonhaawende stroperige draank",
  "item.minecraft.lingering_potion.effect.turtle_master": "Aonhaawende draank der schildpadmester",
  "item.minecraft.lingering_potion.effect.water": "Aonhaawende woaturfles",
  "item.minecraft.lingering_potion.effect.water_breathing": "Aonhaawende draank des woaturojums",
  "item.minecraft.lingering_potion.effect.weakness": "Aonhaawende draank der zwakhèèd",
  "item.minecraft.lingering_potion.effect.weaving": "Aanhoudende drank der weven",
  "item.minecraft.lingering_potion.effect.wind_charged": "Aanhoudende drank des jagende winds",
  "item.minecraft.llama_spawn_egg": "Lamaspawnei",
  "item.minecraft.lodestone_compass": "Kompas wéézend nôàr zèèlstien",
  "item.minecraft.mace": "Knots",
  "item.minecraft.magenta_bundle": "Magenta bundel",
  "item.minecraft.magenta_dye": "Magenta koleurstobber",
  "item.minecraft.magenta_harness": "Magenta tuig",
  "item.minecraft.magma_cream": "Magmacrème",
  "item.minecraft.magma_cube_spawn_egg": "Magmakubusspawnei",
  "item.minecraft.mangrove_boat": "Mangrovehouten boot",
  "item.minecraft.mangrove_chest_boat": "Mangrovehouten boot met kist",
  "item.minecraft.map": "Loze koart",
  "item.minecraft.melon_seeds": "Meloenzaode",
  "item.minecraft.melon_slice": "Meloen stukske",
  "item.minecraft.milk_bucket": "Eemer melluk",
  "item.minecraft.minecart": "Mijnkar",
  "item.minecraft.miner_pottery_shard": "Aardewerkscherf 'mijnwerker'",
  "item.minecraft.miner_pottery_sherd": "Aardewerkscherf 'mijnwerker'",
  "item.minecraft.mojang_banner_pattern": "Banierpatroon",
  "item.minecraft.mojang_banner_pattern.desc": "Mojanglogo",
  "item.minecraft.mojang_banner_pattern.new": "Mojanglogobanierpatroon",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroomspawnei",
  "item.minecraft.mourner_pottery_shard": "Aardewerkscherf 'rouw'",
  "item.minecraft.mourner_pottery_sherd": "Aardewerkscherf 'rouw'",
  "item.minecraft.mule_spawn_egg": "Muileezelspawnei",
  "item.minecraft.mushroom_stew": "Paddestuulestoofpot",
  "item.minecraft.music_disc_11": "Muziekplaat",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Meziekplôat",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Muziekplaat",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Muziekplaat",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Muziekplaat",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Muziekplaat",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Muziekplaat",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Muziekplaat",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Muziekplaat",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Muziekplaat",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Muziekplaat",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Muziekplaat",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Muziekplaat",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Muziekplaat",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Muziekplaat",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Muziekplaat",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Muziekplaat",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Muziekplaat",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Muziekplaat",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Muziekplaat",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Muziekplaat",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Raaw schaopenvlis",
  "item.minecraft.name_tag": "Naomkòrtje",
  "item.minecraft.nautilus_shell": "Nautilusschelp",
  "item.minecraft.nautilus_spawn_egg": "Nautilusspawnei",
  "item.minecraft.nether_brick": "Netherbakstien",
  "item.minecraft.nether_star": "Netherstaar",
  "item.minecraft.nether_wart": "Netherkruid",
  "item.minecraft.netherite_axe": "Netherieten bèèl",
  "item.minecraft.netherite_boots": "Netherieten lers",
  "item.minecraft.netherite_chestplate": "Netherieten borstploat",
  "item.minecraft.netherite_helmet": "Netherieten butsmuts",
  "item.minecraft.netherite_hoe": "Netherieten schrepel",
  "item.minecraft.netherite_horse_armor": "Netherieten paardenharnas",
  "item.minecraft.netherite_ingot": "Netherietstoaf",
  "item.minecraft.netherite_leggings": "Netherieten bienstukken",
  "item.minecraft.netherite_nautilus_armor": "Netherieten nautilusharnas",
  "item.minecraft.netherite_pickaxe": "Netherieten houweel",
  "item.minecraft.netherite_scrap": "Netherietschroewt",
  "item.minecraft.netherite_shovel": "Netherieten schup",
  "item.minecraft.netherite_spear": "Netherieten speer",
  "item.minecraft.netherite_sword": "Netherieten zwaord",
  "item.minecraft.netherite_upgrade_smithing_template": "Smeedssjabloon",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherietupgrade",
  "item.minecraft.oak_boat": "Èèkehoutere boèt",
  "item.minecraft.oak_chest_boat": "Eikenhouten boot met kist",
  "item.minecraft.ocelot_spawn_egg": "Ocelottenspawnei",
  "item.minecraft.ominous_bottle": "Onheilspellende fles",
  "item.minecraft.ominous_trial_key": "Onheilspellende beproevingssleutel",
  "item.minecraft.orange_bundle": "Oranje bundel",
  "item.minecraft.orange_dye": "Oranje koleurstobber",
  "item.minecraft.orange_harness": "Oranje tuig",
  "item.minecraft.painting": "Schildereej",
  "item.minecraft.pale_oak_boat": "Bleke eikenhouten boot",
  "item.minecraft.pale_oak_chest_boat": "Bleke eikenhouten boot met kist",
  "item.minecraft.panda_spawn_egg": "Pandaspawnei",
  "item.minecraft.paper": "Pampier",
  "item.minecraft.parched_spawn_egg": "Zorenspawnei",
  "item.minecraft.parrot_spawn_egg": "Pappegoiespawnei",
  "item.minecraft.phantom_membrane": "Fantoommembraon",
  "item.minecraft.phantom_spawn_egg": "Fantomenspawnei",
  "item.minecraft.pig_spawn_egg": "Verrukespawnei",
  "item.minecraft.piglin_banner_pattern": "Banierpatroon",
  "item.minecraft.piglin_banner_pattern.desc": "Sneut",
  "item.minecraft.piglin_banner_pattern.new": "Snoetbanierpatroon",
  "item.minecraft.piglin_brute_spawn_egg": "Piglinbruutspawnei",
  "item.minecraft.piglin_spawn_egg": "Piglinspawnei",
  "item.minecraft.pillager_spawn_egg": "Roverspawnei",
  "item.minecraft.pink_bundle": "Roze bundel",
  "item.minecraft.pink_dye": "Raaze koleurstobber",
  "item.minecraft.pink_harness": "Roze tuig",
  "item.minecraft.pitcher_plant": "Bekerplant",
  "item.minecraft.pitcher_pod": "Bekerplantpeul",
  "item.minecraft.plenty_pottery_shard": "Aardewerkscherf 'overvloed'",
  "item.minecraft.plenty_pottery_sherd": "Aardewerkscherf 'overvloed'",
  "item.minecraft.poisonous_potato": "Giftège erpel",
  "item.minecraft.polar_bear_spawn_egg": "Èèsbèèrespawnei",
  "item.minecraft.popped_chorus_fruit": "Gepoft chorusfroët",
  "item.minecraft.porkchop": "Raaw kuusvlis",
  "item.minecraft.potato": "Erpel",
  "item.minecraft.potion": "Draank",
  "item.minecraft.potion.effect.awkward": "Vreemde draank",
  "item.minecraft.potion.effect.empty": "Onmoakbare draank",
  "item.minecraft.potion.effect.fire_resistance": "Draank der vuurbestendeghèèd",
  "item.minecraft.potion.effect.harming": "Draank der verwonding",
  "item.minecraft.potion.effect.healing": "Draank der genezing",
  "item.minecraft.potion.effect.infested": "Drank der infestatie",
  "item.minecraft.potion.effect.invisibility": "Draank der onzichtbaorhèèd",
  "item.minecraft.potion.effect.leaping": "Draank der sprongen",
  "item.minecraft.potion.effect.levitation": "Draank der zweving",
  "item.minecraft.potion.effect.luck": "Draank des geluks",
  "item.minecraft.potion.effect.mundane": "Triviale draank",
  "item.minecraft.potion.effect.night_vision": "Draank des nachtzichts",
  "item.minecraft.potion.effect.oozing": "Drank der slijmerigheid",
  "item.minecraft.potion.effect.poison": "Draank des gifs",
  "item.minecraft.potion.effect.regeneration": "Draank der regeneraosie",
  "item.minecraft.potion.effect.slow_falling": "Draank der valvertraoging",
  "item.minecraft.potion.effect.slowness": "Draank der traoghèèd",
  "item.minecraft.potion.effect.strength": "Draank der kracht",
  "item.minecraft.potion.effect.swiftness": "Draank der vlothèèd",
  "item.minecraft.potion.effect.thick": "Stroperège draank",
  "item.minecraft.potion.effect.turtle_master": "Draank der schildpadmester",
  "item.minecraft.potion.effect.water": "Woaturfles",
  "item.minecraft.potion.effect.water_breathing": "Draank des woaturojums",
  "item.minecraft.potion.effect.weakness": "Draank der zwakhèèd",
  "item.minecraft.potion.effect.weaving": "Drank der weven",
  "item.minecraft.potion.effect.wind_charged": "Drank des jagende winds",
  "item.minecraft.pottery_shard_archer": "Aardewerkscherf 'boogschutter'",
  "item.minecraft.pottery_shard_arms_up": "Aardewerkscherf 'geheven armen'",
  "item.minecraft.pottery_shard_prize": "Aardewerkscherf 'prijs'",
  "item.minecraft.pottery_shard_skull": "Aardewerkscherf 'schedel'",
  "item.minecraft.powder_snow_bucket": "Eemer poejersneuw",
  "item.minecraft.prismarine_crystals": "Prismarienkristalle",
  "item.minecraft.prismarine_shard": "Prismarienscherf",
  "item.minecraft.prize_pottery_shard": "Aardewerkscherf 'prijs'",
  "item.minecraft.prize_pottery_sherd": "Aardewerkscherf 'prijs'",
  "item.minecraft.pufferfish": "Kûgelvès",
  "item.minecraft.pufferfish_bucket": "Eemer kûgelvès",
  "item.minecraft.pufferfish_spawn_egg": "Kûgelviesespawnei",
  "item.minecraft.pumpkin_pie": "Pompoenvloai",
  "item.minecraft.pumpkin_seeds": "Pompoenpitten",
  "item.minecraft.purple_bundle": "Paarse bundel",
  "item.minecraft.purple_dye": "Péérse koleurstobber",
  "item.minecraft.purple_harness": "Paars tuig",
  "item.minecraft.quartz": "Netherkwerts",
  "item.minecraft.rabbit": "Raaw knijnenvlis",
  "item.minecraft.rabbit_foot": "Knijnenpotje",
  "item.minecraft.rabbit_hide": "Knijnenvel",
  "item.minecraft.rabbit_spawn_egg": "Knijnenspawnei",
  "item.minecraft.rabbit_stew": "Knijnenstoefpot",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Harnasversiering 'fokker'",
  "item.minecraft.ravager_spawn_egg": "Verwoesterspawnei",
  "item.minecraft.raw_copper": "Ruw koper",
  "item.minecraft.raw_gold": "Ruw gawt",
  "item.minecraft.raw_iron": "Ruw èèzer",
  "item.minecraft.recovery_compass": "Herstelkompas",
  "item.minecraft.red_bundle": "Rode bundel",
  "item.minecraft.red_dye": "Rooie koleurstobber",
  "item.minecraft.red_harness": "Rood tuig",
  "item.minecraft.redstone": "Redstonestobber",
  "item.minecraft.resin_brick": "Harsbaksteen",
  "item.minecraft.resin_clump": "Harsdruppel",
  "item.minecraft.rib_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Harnasversiering 'rib'",
  "item.minecraft.rotten_flesh": "Bedeureve vlis",
  "item.minecraft.saddle": "Zoal",
  "item.minecraft.salmon": "Raawe zalm",
  "item.minecraft.salmon_bucket": "Eemer zalm",
  "item.minecraft.salmon_spawn_egg": "Zalmspawnei",
  "item.minecraft.scrape_pottery_sherd": "Aardewerkscherf 'schrapen'",
  "item.minecraft.scute": "Hoornschild",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Harnasversiering 'schildwacht'",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Harnasversiering 'vormer'",
  "item.minecraft.sheaf_pottery_shard": "Aardewerkscherf 'schoof'",
  "item.minecraft.sheaf_pottery_sherd": "Aardewerkscherf 'schoof'",
  "item.minecraft.shears": "Scher",
  "item.minecraft.sheep_spawn_egg": "Schaopespawnei",
  "item.minecraft.shelter_pottery_shard": "Aardewerkscherf 'schuilplaats'",
  "item.minecraft.shelter_pottery_sherd": "Aardewerkscherf 'schuilplaats'",
  "item.minecraft.shield": "Schild",
  "item.minecraft.shield.black": "Zwart schild",
  "item.minecraft.shield.blue": "Blauw schild",
  "item.minecraft.shield.brown": "Bruin schild",
  "item.minecraft.shield.cyan": "Turquoise schild",
  "item.minecraft.shield.gray": "Grijs schild",
  "item.minecraft.shield.green": "Grún schild",
  "item.minecraft.shield.light_blue": "Lichtblauw schild",
  "item.minecraft.shield.light_gray": "Lichtgrijs schild",
  "item.minecraft.shield.lime": "Lichtgroen schild",
  "item.minecraft.shield.magenta": "Magenta schild",
  "item.minecraft.shield.orange": "Oranje schild",
  "item.minecraft.shield.pink": "Roze schild",
  "item.minecraft.shield.purple": "Péérs schild",
  "item.minecraft.shield.red": "Rooi schild",
  "item.minecraft.shield.white": "Wit schild",
  "item.minecraft.shield.yellow": "Geel schild",
  "item.minecraft.shulker_shell": "Shulkerschelp",
  "item.minecraft.shulker_spawn_egg": "Shulkerspawnei",
  "item.minecraft.sign": "Bord",
  "item.minecraft.silence_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Harnasversiering 'stilte'",
  "item.minecraft.silverfish_spawn_egg": "Zilvervissenspawnei",
  "item.minecraft.skeleton_horse_spawn_egg": "Skeletpeerdespawnei",
  "item.minecraft.skeleton_spawn_egg": "Skelettenspawnei",
  "item.minecraft.skull_banner_pattern": "Banierpatroon",
  "item.minecraft.skull_banner_pattern.desc": "Schedelwaope",
  "item.minecraft.skull_banner_pattern.new": "Schedelwapenbanierpatroon",
  "item.minecraft.skull_pottery_shard": "Aardewerkscherf 'schedel'",
  "item.minecraft.skull_pottery_sherd": "Aardewerkscherf 'schedel'",
  "item.minecraft.slime_ball": "Sleumbal",
  "item.minecraft.slime_spawn_egg": "Sleumkubusspawnei",
  "item.minecraft.smithing_template": "Smeedssjabloon",
  "item.minecraft.smithing_template.applies_to": "Van toepassing op:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Staaf of kristal toevoegen",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Harnas",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Harnasstuk toevoegen",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Staven en kristallen",
  "item.minecraft.smithing_template.ingredients": "Ingrediënten:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Netherietstaaf toevoegen",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamanten uitrusting",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Diamanten harnas, wapen of gereedschap toevoegen",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherietstaaf",
  "item.minecraft.smithing_template.upgrade": "Upgrade(s): ",
  "item.minecraft.sniffer_spawn_egg": "Snuffelaarspawnei",
  "item.minecraft.snort_pottery_shard": "Aardewerkscherf 'snuffelen'",
  "item.minecraft.snort_pottery_sherd": "Aardewerkscherf 'snuffelen'",
  "item.minecraft.snout_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Harnasversiering 'snoet'",
  "item.minecraft.snow_golem_spawn_egg": "Sneeuwgolemspawnei",
  "item.minecraft.snowball": "Sneuwbal",
  "item.minecraft.spectral_arrow": "Spectrale pèèl",
  "item.minecraft.spider_eye": "Spinnenôôg",
  "item.minecraft.spider_spawn_egg": "Spinnespawnei",
  "item.minecraft.spire_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Harnasversiering 'piek'",
  "item.minecraft.splash_potion": "Spattende draank",
  "item.minecraft.splash_potion.effect.awkward": "Spattende vreemde draank",
  "item.minecraft.splash_potion.effect.empty": "Spattende onmoakbare draank",
  "item.minecraft.splash_potion.effect.fire_resistance": "Spattende draank der vuurbestendeghèèd",
  "item.minecraft.splash_potion.effect.harming": "Spattende draank der verwonding",
  "item.minecraft.splash_potion.effect.healing": "Spattende draank der genezing",
  "item.minecraft.splash_potion.effect.infested": "Spattende drank der infestatie",
  "item.minecraft.splash_potion.effect.invisibility": "Spattende draank der onzichtbaorhèèd",
  "item.minecraft.splash_potion.effect.leaping": "Spattende draank der sprongen",
  "item.minecraft.splash_potion.effect.levitation": "Spattende draank der zweving",
  "item.minecraft.splash_potion.effect.luck": "Spattende draank des geluks",
  "item.minecraft.splash_potion.effect.mundane": "Spattende triviale draank",
  "item.minecraft.splash_potion.effect.night_vision": "Spattende draank des nachtzichts",
  "item.minecraft.splash_potion.effect.oozing": "Spattende drank der slijmerigheid",
  "item.minecraft.splash_potion.effect.poison": "Spattende draank des gifs",
  "item.minecraft.splash_potion.effect.regeneration": "Spattende draank der regeneraosie",
  "item.minecraft.splash_potion.effect.slow_falling": "Spattende draank der valvertraoging",
  "item.minecraft.splash_potion.effect.slowness": "Spattende draank der traoghèèd",
  "item.minecraft.splash_potion.effect.strength": "Spattende draank der kracht",
  "item.minecraft.splash_potion.effect.swiftness": "Spattende draank der vlothèèd",
  "item.minecraft.splash_potion.effect.thick": "Spattende stroperège draank",
  "item.minecraft.splash_potion.effect.turtle_master": "Spattende draank der schildpadmester",
  "item.minecraft.splash_potion.effect.water": "Spattende woaturfles",
  "item.minecraft.splash_potion.effect.water_breathing": "Spattende draank des woaturojums",
  "item.minecraft.splash_potion.effect.weakness": "Spattende draank der zwakhèèd",
  "item.minecraft.splash_potion.effect.weaving": "Spattende drank der weven",
  "item.minecraft.splash_potion.effect.wind_charged": "Spattende drank des jagende winds",
  "item.minecraft.spruce_boat": "Sparrenhoutere boot",
  "item.minecraft.spruce_chest_boat": "Sparrenhouten boot met kist",
  "item.minecraft.spyglass": "Verrekèèker",
  "item.minecraft.squid_spawn_egg": "Enkviesespawnei",
  "item.minecraft.stick": "Stok",
  "item.minecraft.stone_axe": "Stienen bèèl",
  "item.minecraft.stone_hoe": "Stienen schreepel",
  "item.minecraft.stone_pickaxe": "Stienen houweel",
  "item.minecraft.stone_shovel": "Stienen schup",
  "item.minecraft.stone_spear": "Stenen speer",
  "item.minecraft.stone_sword": "Stienen zwaord",
  "item.minecraft.stray_spawn_egg": "Verdwaoldespawnei",
  "item.minecraft.strider_spawn_egg": "Lavarijerspawnei",
  "item.minecraft.string": "Draoj",
  "item.minecraft.sugar": "Sokker",
  "item.minecraft.suspicious_stew": "Gehèèmzinnège stoefpot",
  "item.minecraft.sweet_berries": "Zuutbizemmen",
  "item.minecraft.tadpole_bucket": "Emmer kikkervis",
  "item.minecraft.tadpole_spawn_egg": "Kikkervisspawnei",
  "item.minecraft.tide_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Harnasversiering 'getijde'",
  "item.minecraft.tipped_arrow": "Getipte pèèl",
  "item.minecraft.tipped_arrow.effect.awkward": "Getipte pijl",
  "item.minecraft.tipped_arrow.effect.empty": "Onmoakbare getipte pèèl",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Pèèl der vuurbestendeghèèd",
  "item.minecraft.tipped_arrow.effect.harming": "Pèèl der verwonding",
  "item.minecraft.tipped_arrow.effect.healing": "Pèèl der genezing",
  "item.minecraft.tipped_arrow.effect.infested": "Pijl der infestatie",
  "item.minecraft.tipped_arrow.effect.invisibility": "Pèèl der onzichtbaarhèèd",
  "item.minecraft.tipped_arrow.effect.leaping": "Pèèl der sprongen",
  "item.minecraft.tipped_arrow.effect.levitation": "Pèèl der zweving",
  "item.minecraft.tipped_arrow.effect.luck": "Pèèl des geluks",
  "item.minecraft.tipped_arrow.effect.mundane": "Getipte pijl",
  "item.minecraft.tipped_arrow.effect.night_vision": "Pèèl der nachtzicht",
  "item.minecraft.tipped_arrow.effect.oozing": "Pijl der slijmerigheid",
  "item.minecraft.tipped_arrow.effect.poison": "Pèèl des gifs",
  "item.minecraft.tipped_arrow.effect.regeneration": "Pèèl der regeneraosie",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Pèèl der valvertraoging",
  "item.minecraft.tipped_arrow.effect.slowness": "Pèèl der traoghèèd",
  "item.minecraft.tipped_arrow.effect.strength": "Pèèl der kracht",
  "item.minecraft.tipped_arrow.effect.swiftness": "Pèèl der snelhèèd",
  "item.minecraft.tipped_arrow.effect.thick": "Getipte pijl",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Pèèl der schildpadmester",
  "item.minecraft.tipped_arrow.effect.water": "Pèèl der spatting",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Pèèl des woaturojums",
  "item.minecraft.tipped_arrow.effect.weakness": "Pèèl der zwakhèèd",
  "item.minecraft.tipped_arrow.effect.weaving": "Pijl der weven",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Pijl des jagende winds",
  "item.minecraft.tnt_minecart": "Mijnkar meej TNT",
  "item.minecraft.torchflower_seeds": "Fakkelbloemzaden",
  "item.minecraft.totem_of_undying": "Totem der onsterfelekhèèd",
  "item.minecraft.trader_llama_spawn_egg": "Handelaorslamaspawnei",
  "item.minecraft.trial_key": "Beproevingssleutel",
  "item.minecraft.trident": "Dreitaand",
  "item.minecraft.tropical_fish": "Tropische vès",
  "item.minecraft.tropical_fish_bucket": "Eemer tropische vès",
  "item.minecraft.tropical_fish_spawn_egg": "Tropischeviesespawnei",
  "item.minecraft.turtle_helmet": "Schildpadschild",
  "item.minecraft.turtle_scute": "Schildpadhoornschild",
  "item.minecraft.turtle_spawn_egg": "Schildpaddespawnei",
  "item.minecraft.vex_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Harnasversiering 'ergernis'",
  "item.minecraft.vex_spawn_egg": "Ergernissespawnei",
  "item.minecraft.villager_spawn_egg": "Turpelingespawnei",
  "item.minecraft.vindicator_spawn_egg": "Verdedigerspawnei",
  "item.minecraft.wandering_trader_spawn_egg": "Rondrèèzendehandelaorsspawnei",
  "item.minecraft.ward_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Harnasversiering 'hoeder'",
  "item.minecraft.warden_spawn_egg": "Hoederspawnei",
  "item.minecraft.warped_fungus_on_a_stick": "Spoèkaetige zwam an 'n stok",
  "item.minecraft.water_bucket": "Eemer woatur",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Harnasversiering 'padvinder'",
  "item.minecraft.wheat": "Terf",
  "item.minecraft.wheat_seeds": "Terf zaode",
  "item.minecraft.white_bundle": "Witte bundel",
  "item.minecraft.white_dye": "Wiete koleurstobber",
  "item.minecraft.white_harness": "Wit tuig",
  "item.minecraft.wild_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Harnasversiering 'verwilderd'",
  "item.minecraft.wind_charge": "Windvlaag",
  "item.minecraft.witch_spawn_egg": "Heksespawnei",
  "item.minecraft.wither_skeleton_spawn_egg": "Witherskelettenspawnei",
  "item.minecraft.wither_spawn_egg": "Witherspawnei",
  "item.minecraft.wolf_armor": "Wolvenharnas",
  "item.minecraft.wolf_spawn_egg": "Wolvespawnei",
  "item.minecraft.wooden_axe": "Houtere bèèl",
  "item.minecraft.wooden_hoe": "Houtere schreepel",
  "item.minecraft.wooden_pickaxe": "Houtere houweel",
  "item.minecraft.wooden_shovel": "Houtere schup",
  "item.minecraft.wooden_spear": "Houten speer",
  "item.minecraft.wooden_sword": "Houtere zwaord",
  "item.minecraft.writable_book": "Buuk en vèr",
  "item.minecraft.written_book": "Geschrève buuk",
  "item.minecraft.yellow_bundle": "Gele bundel",
  "item.minecraft.yellow_dye": "Gele koleurstobber",
  "item.minecraft.yellow_harness": "Geel tuig",
  "item.minecraft.zoglin_spawn_egg": "Zoglinspawnei",
  "item.minecraft.zombie_horse_spawn_egg": "Zombiepeerdspawnei",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombienautilusspawnei",
  "item.minecraft.zombie_spawn_egg": "Zombiespawnei",
  "item.minecraft.zombie_villager_spawn_egg": "Zombieturpelingespawnei",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombiepiglinspawnei"
}
export const brb = items; 
